<template>
  <div>
    <v-container class="input-text-size pt-1">
      <div id="crud-list-2-0">
        <v-data-table
          dense
          :headers="headers"
          class="elevation-1 input-text-size"
          :items="editedItem"
          item-key="key"
          :hide-default-footer="editedItem.length <= 100"
          single-expand
          :disable-pagination="editedItem.length <= 100"
          :items-per-page="100"
          :footer-props="{
            itemsPerPageOptions: [100, 200, 500, -1],
            showFirstLastPage: true,
            showCurrentPage: true
          }"
          >
          <!-- :expanded.sync="expanded" -->
          <template v-slot:top>
            <div class="d-flex justify-space-between align-center">
              <p>Tax Details</p>
              <!-- Lookup-only control: resolves a parcel to every unpaid tax record on it and
                   loads them as rows. Never persisted with the payment. -->
              <div class="d-flex align-center">
                <v-text-field
                  v-model="parcelLookupId"
                  label="Parcel ID"
                  hide-details
                  style="width: 240px;"
                  class="input-text-size dialog-tax-details-parcel-lookup"
                  id="dialogTaxDetailsParcelLookup"
                  ref="parcelLookupRef"
                  :autofocus="defaultCursorToParcelID"
                  :loading="parcelLookupLoading"
                  @input="parcelLookupByTimeOut"
                  @keydown.enter.prevent.stop="loadUnpaidsByParcelId()"
                  @blur="loadUnpaidsByParcelId()" />
              </div>
              <v-btn
              :class="handlePlusClass()"
                color="primary"
                fab
                icon
                x-small
                @click="addOneFromPlusButton"
                class="dialog-tax-details-add-btn"
                id="dialogTaxDetailsAddBtn"
              >
                <v-icon :class="handlePlusClass()">
                  {{ icons.mdiPlus }}
                </v-icon>
              </v-btn>
            </div>
          </template>
          <template v-slot:[`header.selected`]>
            <v-checkbox
              v-model="selectAllChecked"
              @change="toggleSelectAll"
              hide-details
              dense
            />
          </template>
          <template v-slot:item="{ item , index}">
            <tr @click="toggleExpand(item, index)">
            <td class="flex" style="width: 50px;">
              <v-checkbox
                v-model="item.selected"
                @change="handleSelectionChange"
                hide-details
                dense
                @click.stop
                :disabled="item.posted"
              />
            </td>
            <td>
              <span v-if="item.AIsVisible" class="ChangeColor">A</span>
            </td>
            <td>
            <v-select
              style="width: 80px;"
              class="input-text-size dialog-tax-details-select"
              id="dialogTaxDetailsSelect"
               v-model.number="item.taxType"
              :rules="reqdTaxTypeValidation"
              hide-details="auto"
              dense
              :items="taxType"
              item-text="label"
              item-value="value"
              flat
              solo
              @blur="onTypeChange()"
              @click="onTypeClick()"
              @change="somethingChanged(), onTypeChange(), handleManualChanges(index, item)"
               :disabled="item.posted || item.void"
            />
            </td>
          <td>
            <!-- cannot use v-model.number while using barcode scanner -->
            <v-text-field v-model="item.taxYear" hide-details dense
              class="dialog-tax-details-tax-year"
              id="dialogTaxDetailsTaxYear"
              @blur="somethingChanged(), preUpdateEditedItem(item, index, true)"
              @input="handleBarCodeScan(item.taxYear, index)"
              @keydown.enter.prevent.stop="handleEnterKey(item, index)"
              :loading="lookupLoadingIndex === index"
              flat
              solo
              ref="taxYearRef"
              :autofocus="taxYearAutoFocus"
              @focus="$event.target.select()"
              :disabled="item.posted || item.void || !item.itsNewRecord" />
            </td>
            <td>
            <v-text-field v-model="item.taxId" hide-details dense
              class="dialog-tax-details-tax-id"
              id="dialogTaxDetailsTaxId"
              style="width: 100px;"
              @blur="somethingChanged(), preUpdateEditedItem(item, index, true)"
              flat solo ref=taxIdRef
              :disabled="item.posted || item.void || !item.itsNewRecord" />
            </td>
            <td>
            <v-text-field style="width: 200px;" v-model="item.ownerName"
              class="dialog-tax-details-owner-name"
              id="dialogTaxDetailsOwnerName"
             hide-details dense readonly flat solo />
            </td>
            <td class="dialog-tax-details-property-tax-type tax-type-col">
              {{ propertyTaxTypeShortCode(item.propertyTaxType) }}
            </td>
            <!-- Receipt / Cert No - shares its header slot, see getHeaders() -->
            <td>
            <v-text-field
              :value="showCertNumber ? item.certNumber : item.reciept"
              hide-details dense
              class="dialog-tax-details-reciept"
              id="dialogTaxDetailsReciept"
              disabled flat solo />
            </td>
            <td>
            <v-text-field hide-details dense v-model="item.taxAmt"
              class="dialog-tax-details-tax-amt"
              id="dialogTaxDetailsTaxAmt"

              @change="handleManualChanges(index, item)"
              @blur="somethingChanged(), roundAmount('taxAmt', index), calculateTotalDue(index)"
              @focus="amountToNum('taxAmt',index), $event.target.select()"
              flat solo :disabled="checkDisableTax()
               || item.posted || item.void || item.allowBackTaxEdit" />
            </td>
            <td>
            <v-checkbox v-model="item.Half" hide-details
              class="dialog-tax-details-half-checkbox"
              id="dialogTaxDetailsHalfCheckbox"
              dense @change="(val) => isHalfPayment(val, index)"
              :disabled=" item.posted || item.void || item.disableHalf
               || !item.itsNewRecord || statusForHalf(item.taxAmt)" />
            </td>
            <td>
            <v-text-field
              v-model="item.penaltyAmt"
              hide-details
              dense
              class="dialog-tax-details-penalty-amt"
              id="dialogTaxDetailsPenaltyAmt"
              @blur="somethingChanged(), roundAmount('penaltyAmt', index), calculateTotalDue(index)"
              @focus="amountToNum('penaltyAmt',index), $event.target.select()"
              @change="handleManualChanges(index, item),penaltyChangeManually(index, item)"
              flat
              solo
               :disabled="item.posted || item.void || !paymentSettingItem.changePenalty"
               >
              </v-text-field>
            </td>
            <td>
              <v-text-field
              hide-details
              v-model="item.totalFees"
              dense
              class="dialog-tax-details-total-fees"
              id="dialogTaxDetailsTotalFees"
              @blur="somethingChanged(),handleManualChanges(index, item)"
              flat
              solo
              :disabled="item.posted || item.void"
              readonly
              >
              <template v-slot:append>
                <v-icon small @click="openFeesEditDialog(item, index)"
                :disabled="item.void">
                  {{ icons.mdiPencil }}
                </v-icon>
              </template>
            </v-text-field>
            </td>
            <td>
            <v-text-field
              v-model.number="item.total"
              hide-details
              dense
              class="dialog-tax-details-total"
              id="dialogTaxDetailsTotal"
              @change="handleManualChanges(index, item)"
              @focus="amountToNum('total',index), $event.target.select()"
              @blur="somethingChanged(), roundAmount('total', index)"
              flat
              solo
              readonly
            >
            </v-text-field>
            </td>
            <td>
            {{ item.posted ? 'Y':'N' }}
            </td>
            <td>
              {{ item.protest ? 'Y':'N' }}
            </td>
            <td class="flex" style="width: 0%;">
            <v-checkbox
              style="width: 17px;"
              v-model="item.tempVariableVoid"
              @change="(val) => onVoidChange(val, index)"
              hide-details dense
              :disabled="item.posted || item.void" />
            </td>
            <td>
            <v-icon
              small
              hide-details
              dense
              tabindex="-1"
              @click="removeOne(item)"
               :disabled="item.posted || item.void || !!item.reciept"
            >
              {{ icons.mdiDelete }}
            </v-icon>
            </td>
          </tr>
          </template>
              <!-- <template v-slot:expanded-item="{ isOwnerInfoAvailable }">
               {{isOwnerInfoAvailable}}
                <td :colspan="16"
              v-for="item in ownerInfo"
              :key="item._id"
              class="input-text-size blue-font"
            >
            <span>Owner Name: {{item.name1}} ,  </span>
            <span>Tax Due: {{item.totalDue}} , </span>
            <span>Total paid: {{item.totalPaid}}  ,</span>
            <span>penalty Date:
              {{item.penaltyStartDate && toShortDate(item.penaltyStartDate)}} </span>
              </td>
          </template> -->
          <template slot="body.append">
            <tr class="sticky-table-footer">
          <td v-for="(header, index) in headers" :key="index"
          :class="getAlignment(header.value)">
            <strong>
              {{ footerList[index] }}
            </strong>
          </td>
        </tr>
          </template>
        </v-data-table>
        <v-row class="">
<v-col cols="2" class="pb-1">
<div class="blue-text-left">Mtg Code:
  {{ (ownerInfo || []).length > 0 ? `${ownerInfo[0].mtgCode || ''} ` :'' }} </div>
</v-col>
<v-col cols="2" class="pb-1">
  <div v-if="isThereAnyUnpaids" class="blue-text-left" style="color: red !important;">
    Other Taxes Due</div>
</v-col>
<v-col cols="2" class="pb-1">
  <v-btn class="mt-2" v-if="isThereAnyUnpaids" color="error"
   absolutecolor="primary" small @click="addUnpaidTaxes('fromBtnClick')">Add All Unpaids</v-btn>
</v-col>
<v-col cols="2" class="pb-1" v-if="!isItFromLargePayments">
  <v-btn class="mt-2 glow-on-for-add-all-unpaids"
   absolutecolor="primary" small @click="addComments">Add Comment</v-btn>
</v-col>
<v-col cols="2" class="pb-1" v-else></v-col>
<!-- <v-col cols="2" class="pb-1"></v-col> -->
<v-col cols="4" class="pb-1">
  <div class="blue-text">Running Total: {{totalSum}}</div></v-col>
</v-row>
    </div>
    <!-- <span v-if="loadMoreTaxBtn">
    <v-btn  elevated @click="moreTaxFields" color="primary" small rounded> load more</v-btn>
    </span> -->
    </v-container>
    <v-dialog v-model="editFeesDialog" max-width="500" class="input-text-size
    dialog-tax-details-edit-fees" id="dialogTaxDetailsEditFees">
      <v-card>
        <v-row justify="space-between" class="px-4">
          <v-card-title class="input-text-size">Edit Fees</v-card-title>
          <v-icon
            @click="addNewFeeRow"
            color="error"
            class="mr-4 mt-4 dialog-tax-details-add-fee-icon"
            id="dialogTaxDetailsAddFeeIcon"
          >
            {{ icons.mdiPlus }}
          </v-icon>
        </v-row>
        <v-card-text class="input-text-size">
          <div id="crud-list-2-0">
            <v-data-table
              :headers="feeHeaders"
              :items-per-page="30"
              :items="feeseditDialog"
              class="hide-footer-select elevation-1 input-text-size dialog-tax-details-fees-table"
              id="dialogTaxDetailsFeesTable"
              hide-default-footer
              fixed-header
              style="max-height: 300px; overflow-y: auto">
              <template v-slot:[`item.feeNumber`]="{ item, index }">
                <v-select
                  v-model="item.feeNumber"
                  :items="taxFeeMasterData"
                  :item-text="item => `${item.feeNumber} - ${item.feeDescription}`"
                  item-value="feeNumber"
                  dense
                  class="input-text-size dialog-tax-details-fee-select"
                  id="dialogTaxDetailsFeeSelect"
                  @change="handleFeeNumberChange($event, index)"
                  :disabled="!!selTaxDet.posted"
                >
                </v-select>
              </template>
              <template v-slot:[`item.feeAmount`]="{ item, index }">
                <v-text-field
                  v-model="item.feeAmount"
                  @blur="roundAmountForFee(item.feeAmount, index)"
                  @focus="amountToNumForFee(item.feeAmount, index), $event.target.select()"
                  dense
                  class="input-text-size dialog-tax-details-fee-amount"
                  id="dialogTaxDetailsFeeAmount"
                  :disabled="!!selTaxDet.posted"
                >
                </v-text-field>
              </template>
              <template v-slot:[`item.actions`]="{ index }">
                <v-icon small @click="removeFeeRow(index)">
                  {{ icons.mdiDelete }}
                </v-icon>
              </template>
            </v-data-table>
          </div>
        </v-card-text>
        <v-card-actions class="input-text-size dialog-tax-details-edit-fees-actions"
        id="dialogTaxDetailsEditFeesActions">
          <v-btn color="primary" small @click="handleFeesItems(feeseditDialog)"
            :disabled="!!selTaxDet.posted">Save</v-btn>
          <v-btn small @click="closeEditDialog">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addFeeDialog" max-width="500" class="input-text-size">
      <v-card>
        <v-card-title class="input-text-size">Add Fee</v-card-title>
        <v-card-text>
          <TaxFeesTableDialog :baseCrudKey="'addFeeDialog'" :selectedRowItem="selTaxDet"/>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" small @click="handleSaveNewFee">Save</v-btn>
          <v-btn small @click="addFeeDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="commentDialog" max-width="600" class="input-text-size">
      <v-card>
        <v-card-title class="input-text-size">Add Comments</v-card-title>
        <v-card-text class="input-text-size">
          <v-container>
            <v-row>
              <v-col cols="6" class="mt-n3">
                  <CommonDropDowns v-if="commentDialog"
                   :isItCategory=true @change="dataFromCommonDropDowns"
          :commentsCategoryValue="commentData.category" :isCommentsCategoryDisabled="true" />
              </v-col>
               <v-col cols="6" class="pt-2 pb-0 mb-n4 mt-n2">
        <v-autocomplete :items="reasonListDropDown" class="input-text-size" label='Reason Code'
         v-model="commentData.reasonCode" item-text="name" item-value="value" />
      </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <v-checkbox
                  v-model="commentData.addToLegal"
                  label="Add To Legal on Statement"
                  dense
                  hide-details
                  class="input-text-size"
                />
              </v-col>
              <v-col cols="4">
                <v-checkbox
                  v-model="commentData.sendToWebsite"
                  label="Send To Website"
                  dense
                  hide-details
                  class="input-text-size"
                />
              </v-col>
              <v-col cols="4">
                <v-checkbox
                  v-model="commentData.rollToNextYear"
                  label="Roll To Next Year"
                  dense
                  hide-details
                  class="input-text-size"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea
                  v-model="commentData.comment"
                  label="Comments"
                  rows="4"
                  dense
                  outlined
                  hide-details
                  class="input-text-size"
                  placeholder="Enter your comment here..."
                  v-textAreaUppercase=globalSettingItem.conEverythingToCaps
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="input-text-size">
          <v-spacer></v-spacer>
          <v-btn      :class="`input-text-size`"
            text color="blue darken-1"
             small @click="closeCommentDialog">Cancel</v-btn>
          <v-btn   :class="`input-text-size`"
            text color="blue darken-1" small @click="handleBulkCommentSave">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="duplicateTaxDetailDialog" max-width="420" persistent class="input-text-size">
      <v-card>
        <v-card-title class="text-h6 warning--text">
          <v-icon color="warning" class="mr-2">{{ icons.mdiAlert }}</v-icon>
          Duplicate Tax Detail
        </v-card-title>
        <v-card-text class="input-text-size">
          This Tax ID has already been added for the selected Tax Year.
          <br /><br />
          Click <strong>Continue</strong> to add the duplicate, or <strong>Cancel</strong> to remove it.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text small @click="handleDuplicateTaxDetailCancel">Cancel</v-btn>
          <v-btn text small color="warning" @click="handleDuplicateTaxDetailContinue">Continue</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <CommonPopUp v-model="showPendingPaymentPopup" v-if="showPendingPaymentPopup"
    :enableFlashTypeMsg="false" @onEnter="closePendingPaymentPopup('continue')">
      <template v-slot:customsLabelOrInfo>
        <span class="elevation-1">
          <h4 class="ml-5">Pending Payments Found</h4>
          <span
          v-for="(row, index) in pendingPaymentList"
          :key="`pendingPayment-${index}`"><br/>
          <p style="white-space: pre;">
            <v-icon class="ChangeIconYellowColor">
              {{ icons.mdiCircleSlice8 }}
            </v-icon> Tax Yr {{ row.taxYear }} Tax ID {{ row.taxId }} has a pending payment -
      Payment#: {{ row.paymentNumber }}, Date: {{ toShortDate(row.payDate) }}.
          </p>
        </span>
        <br/>
        <p style="white-space: pre;">
          <v-icon class="removeIcon">
            {{ icons.mdiCircleSlice8 }}
          </v-icon> Do you wish to continue?
        </p>
        </span>
      </template>
      <template v-slot:[`customsButtonsForPopUp`]="{}">
        <v-btn :class="`input-text-size`" text color="blue darken-1"
        @click="closePendingPaymentPopup('continue')">Continue for all</v-btn>
        <v-btn :class="`input-text-size`" text color="blue darken-1"
        @click="closePendingPaymentPopup('cancel')">Cancel</v-btn>
      </template>
    </CommonPopUp>
    <CommonPopUp v-model="showOrHidePopUpForAllMsg"
    v-if="showOrHidePopUpForAllMsg && !showPendingPaymentPopup"
    :enableFlashTypeMsg="false" @onEnter="openConfirmPopUpForAllMsg('continue')">
      <template v-slot:customsLabelOrInfo>
        <span class="elevation-1" v-if="(allMessageText || []).length">
          <h4 class="ml-5">{{errorMsgTaxYearTaxId}}</h4>
          <span
          v-for="(textName, index) in allMessageText"
          :key="`${textName.txtName}-${index}`"><br/>
          <p style="white-space: pre;">
            <v-icon :class="handleCircleClass(textName.txtName)">
              {{ icons.mdiCircleSlice8 }}
            </v-icon> {{ textName.txtMsg }}
          </p>
        </span>
      </span>
      <span class="elevation-1" v-if="(entireListErrorMessageText || []).length">
      <h4 class="ml-5">{{errorMsgTaxYearTaxIdFunc}}</h4>
      <span v-for="(textName, index) in (entireListErrorMessageText || [])"
      :key="`${textName.txtName}-${index}`"><br/>
        <p style="white-space: pre;">
          <v-icon :class="handleCircleClass(textName.txtName)">
            {{ icons.mdiCircleSlice8 }}
          </v-icon> {{ textName.txtMsg }}
        </p>
      </span>
      </span>
      </template>
      <template v-slot:[`customsButtonsForPopUp`]="{}">
        <v-btn :class="`input-text-size`" text color="blue darken-1"
        v-if="(allMessageText|| []).length"
        @click="openConfirmPopUpForAllMsg('continue')">Continue</v-btn>
        <v-btn :class="`input-text-size`" text color="blue darken-1"
        v-if="(allMessageText || []).length"
        @click="openConfirmPopUpForAllMsg('Cancel')">Cancel</v-btn>
        <v-btn :class="`input-text-size`" text color="blue darken-1"
        v-if="(entireListErrorMessageText || []).length"
        @click="openConfirmPopUpForAllMsg('continueAll')">Continue for all</v-btn>
        <v-btn :class="`input-text-size`" text color="blue darken-1"
        v-if="(entireListErrorMessageText || []).length"
        @click="openConfirmPopUpForAllMsg('CancelAll')">Cancel</v-btn>
      </template>
    </CommonPopUp>
  </div>
</template>

<script>
import {
  mdiAlert,
  mdiCircleSlice8,
  mdiDelete,
  mdiPencil,
  mdiPlus,
} from '@mdi/js';
import {
  mapActions,
  mapGetters,
  mapMutations, mapState,
} from 'vuex';
import '../../../../assets/style.css';
import { authRoles } from '../../../../router/roleGroups';
import { isAuthorised } from '../../../../store/auth/token';
import { toIsoDate, toShortDate, propertyTaxTypeShortCode } from '../../../../util/shared/tmc-global';
import {
  amountFormat,
  amountToNumber,
} from '../../../../util/shared/vue-global';
import CommonDropDowns from '../../common-utils/CommonDropDowns.mixin.vue';
import CommonPopUp from '../../common-utils/CommonPopUp.vue';
import { getFeeListBasedOnEffeciveDate, getPreviousPenaltyPeriodEnd, taxReasonListDropDownPostProcessTrans } from '../../common-utils/CommonTaxFunctionalities';
import { checkObjPaymentsDiff } from '../../common-utils/CommonTaxPaymentFunctionalities';
import {
  MIN_ALLOW_AMT_HALF, REGEX_VALIDATION, SEARCH_DEBOUNCE_TIMER, TAX_LOOKUP_TIMEOUT_MS,
} from '../../common-utils/constants';
import PaymentCommonFunc from '../../common-utils/PaymentCommonFunc.mixin';
import {
  exemptManufacturingStatusCode,
  getTaxYearStatus, partitionPendingPaymentAlertCodes, penaltyCalculation, resaleExcessUnit,
} from '../../common-utils/tax-common.util';
import TaxFeesTableDialog from '../../TaxInquiry/Common/TaxFeesTableDialog.vue';
import { applyAuditForPayment } from '../audit/paymentAudit.util';
import { dialogTaxDetailsHeaders } from '../paymentutils/PaymentTransactionTableHeaders';
import GlobalToCaps from '../../../../util/shared/GlobalToCaps.mixin.vue';

export default {
  mixins: [PaymentCommonFunc, GlobalToCaps],
  props: {
    baseCrudKey: {
      type: String,
      default: 'paymentTransactionList',
    },
    fiscalYear: {
      type: Number,
      default: 0,
    },
    value: {
      type: Array,
      default: () => [],
    },
    isItFromJuneResale: {
      type: Boolean,
      default: false,
    },
    selectedComponentCriteria: {
      type: Object,
      default: () => { },
    },
    isItFromLargePayments: {
      type: Boolean,
      default: false,
    },
    // loadMoreTaxBtn: {
    //   type: Boolean,
    //   default: false,
    // },
  },
  components: {
    CommonPopUp,
    TaxFeesTableDialog,
    CommonDropDowns,
  },
  data() {
    return {
      resaleFeeApplied: false,
      headers: this.getHeaders(),
      feeHeaders: [
        { text: 'Fee', value: 'feeNumber', align: 'start' },
        { text: 'Amount', value: 'feeAmount' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      editFeesDialog: false,
      addFeeDialog: false,
      feeseditDialog: {},
      originalFeesBackup: [], // Backup of original fees for cancel functionality
      commentDialog: false,
      commentDialogCrudKey: 'bulkCommentDialog',
      commentData: {
        category: 7, // Default category for user comments
        reasonCode: null,
        addToLegal: false,
        sendToWebsite: false,
        rollToNextYear: false,
        comment: '',
      },
      selectAllChecked: false,
      icons: {
        mdiAlert,
        mdiDelete,
        mdiPlus,
        mdiPencil,
        mdiCircleSlice8,
      },
      // Parcel ID lookup field. Local-only: it is never emitted with the tax details, so it
      // cannot reach taxpayments / paymenttaxdetails / audits.
      parcelLookupId: '',
      parcelLookupLoading: false,
      parcelLookupTimerId: null,
      ownerInfo: [],
      selTaxDet: {},
      feeDetailsIndex: undefined,
      expanded: [],
      taxType: [],
      defaultId: 0,
      paymentTaxes: [],
      showOrHidePopUpForAllMsg: false,
      isUnpaidFlag: false, // this used to stop this func commonUpdateEditedItem from triggering
      currentIndex: 0,
      allMessageText: [],
      loadTaxIndex: 0,
      moreTaxLimit: 30,
      // receiptNumberLocalCounter: [],
      defaultItem: {
        // taxYear: this.latestTaxYear || 0,
        taxId: null,
        schoolDistrict: '',
        taxAmt: null,
        reciept: null,
        certNumber: null,
        penaltyAmt: null,
        total: null,
        originalTaxAmt: null,
        Half: false,
        itsNewRecord: true,
        thereIsAPrevUnptRec: false,
      },
      isItBarcodeScanner: false,
      // Set between a complete barcode arriving and the row being written, so the trailing
      // characters of that same scan are not treated as a second barcode.
      scanBeingHandled: false,
      // Lookups that arrived while another was in flight, waiting their turn - see queueLookup.
      pendingLookups: [],
      lookupWatchdog: null,
      // Row whose lookup is outstanding, for the Tax Yr field's :loading bar. Deliberately a
      // progress bar and not a disabled field: disabling would blur the field (firing its own
      // lookup) and, worse, would send the next scan's keystrokes to document.body, where they
      // are lost just as silently as the drop this replaces.
      lookupLoadingIndex: -1,
      // Set while "Add All Unpaids" is waiting on a warning modal (status code / mtg code /
      // no taxes due / pending payment) the load raised, so "Add to List" only fires once
      // the clerk has actually seen and dismissed it - see maybeEmitUnpaidTaxesAdded.
      awaitingUnpaidTaxesPopupClose: false,
      statusCodeErrorList: [],
      // rows for the 'Pending Payments Found' popup - 416/419 records resolved to an actual
      // pending payment (paymentNumber/payDate). Shown before, and separately from,
      // showOrHidePopUpForAllMsg.
      pendingPaymentList: [],
      showPendingPaymentPopup: false,
      mtgCodeErrorList: [],
      totalDueZeroErrorList: [],
      paymentExitsErrorList: [],
      errorMsgTaxYearTaxIdList: [],
      errorMsgTaxYearTaxId: '',
      duplicateTaxDetailDialog: false,
      duplicateTaxDetailIndex: null,
      duplicateTaxDetailData: {},
    };
  },
  created() {
    this.onTypeChange();
    // this is required because when the 1st time component is mounted watch method does not work
    this.fromOtherSourcesUpdateEditedItem();
    // Initialize the addFeeDialog store
    this.setItem(['addFeeDialog', []]);
    // Load reason codes for comment dialog
    // this.loadReasonCode();
    this.loadReasonCode({
      criteria: { sortBy: [{ column: 'reasonCode', direction: 'asc' }] },
      postProcessTrans: taxReasonListDropDownPostProcessTrans,
      baseCrudKey: 'reasonListDropDown',
    });
  },
  mounted() {
    // The dialog is already open the first time this renders - v-dialog builds its content
    // lazily - so the isVisibleProp watcher never sees that first transition.
    this.focusParcelLookup();
  },
  beforeDestroy() {
    // a pending parcel lookup must not fire after the dialog is gone
    clearTimeout(this.parcelLookupTimerId);
    clearTimeout(this.updateTimer);
    clearTimeout(this.lookupWatchdog);
    // queued scans belong to rows that no longer exist
    this.pendingLookups = [];
  },
  computed: {
    ...mapGetters('base/crud', ['item', 'isVisible', 'criteria']),
    ...mapGetters([
      'todaysDate',
    ]),
    categoryOptions() {
      return [
        { value: 1, label: '1 - General' },
        { value: 2, label: '2 - Payment' },
        { value: 3, label: '3 - Legal' },
        { value: 4, label: '4 - Exemption' },
        { value: 5, label: '5 - Assessment' },
        { value: 6, label: '6 - Collection' },
        { value: 7, label: '7 - Administrative' },
        { value: 8, label: '8 - Other' },
      ];
    },
    selectedItemsCount() {
      return this.editedItem.filter((item) => item.selected && !item.posted).length;
    },
    selectableItemsCount() {
      return this.editedItem.filter((item) => !item.posted).length;
    },
    ...mapState({
      statusTypes: (state) => state.enums.TaxPaymentEnum || [],
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem,
      halfOrPostmark: (state) => state.tax.taxPayment.halfOrPostmark,
      minimizeTRToggleApiCalls: (state) => state.tax.taxPayment.minimizeTRToggleApiCalls,
      isItTaxRecordNCounter: (state) => state.tax.taxPayment
        .paymentShotCutStore.isItTaxRecordNCounter || 0,
      paymentAddIconStatus: (state) => state.tax.taxPayment
        .paymentShotCutStore.paymentAddIconStatus || false,
      isThereAnyUnpaids: (state) => state.tax.taxPayment.isThereAnyUnpaids,
      scannerMode: (state) => state.tax.taxPayment.scannerMode,
      paymentSettingItem: (state) => state.SystemConfig.paymentSettingItem,
      taxFeeMasterData: (state) => state.shared.taxFeeMaster.taxFeeMasterData || [],
      reasonListDropDown: (state) => state.base.crud.items.reasonListDropDown,
      latestTaxYear: (state) => state.tax.taxCommon.latestTaxYear,
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),
    showCertNumber() {
      return (this.paymentSettingItem || {}).showCertNumberOnPaymentScreen || false;
    },
    // 'Default cursor to Parcel ID' (payment settings). The dialog opens with the cursor in the
    // Parcel ID lookup rather than the first row's Tax Yr, so a parcel-driven clerk can key
    // straight into it. Off - the default - leaves the cursor where it has always been.
    defaultCursorToParcelID() {
      return (this.paymentSettingItem || {}).defaultCursorToParcelID || false;
    },
    // Every row carries this autofocus, so a row loaded by a parcel lookup would pull the cursor
    // back out of the Parcel ID field. Rows the clerk asks for still get it - see focusLastTaxYear.
    taxYearAutoFocus() {
      return !this.defaultCursorToParcelID;
    },
    defaultTaxYearFromTaxSetting() {
      return Number((this.taxSettingItem || {}).taxYear) || 0;
    },
    editedItem: {
      get() {
        const items = JSON.parse(JSON.stringify(this.value));
        const newVal = items.map((item, index) => ({
          ...item,
          total: amountFormat(item.total || 0),
          key: `${index}`,
        }));
        return newVal;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    isOwnerInfoAvailable() {
      return (this.ownerInfo || []).length > 0;
    },
    totalSum() {
      const total = this.editedItem.reduce((acc, item) => {
        // Include items that are TAXPAYMENT or don't have taxType set (new items)
        if (!item.taxType || item.taxType === 'TAXPAYMENT' || item.taxType === 'TAXREFUND') {
          return acc + amountToNumber(item.total || 0);
        }
        return acc;
      }, 0);
      return amountFormat(total || 0);
    },
    isVisibleProp: {
      get() {
        return this.isVisible(this.baseCrudKey);
      },
    },
    footerList() {
      // Blank rows (added via addOne()/addUnpaidTaxes()) have no taxId; exclude them
      // so the count reflects properties/parcels, not raw grid rows
      const noOfRecords = `# ${(this.editedItem || []).filter((item) => item.taxId).length}`;
      // Include items that are TAXPAYMENT or don't have taxType set (new items)
      const taxItemsWithTaxPaymentTaxType = (this.editedItem || []).filter((item) => !item.taxType || item.taxType === 'TAXPAYMENT' || item.taxType === 'TAXREFUND') || [];
      const total = taxItemsWithTaxPaymentTaxType.reduce((acc, item) => acc
       + amountToNumber(item.total || 0), 0);
      const taxAmt = taxItemsWithTaxPaymentTaxType.reduce((acc, item) => acc
      + amountToNumber(item.taxAmt || 0), 0);
      const totalFees = taxItemsWithTaxPaymentTaxType.reduce((acc, item) => acc
      + amountToNumber(item.totalFees || 0), 0);
      const penaltyAmt = taxItemsWithTaxPaymentTaxType.reduce((acc, item) => acc
      + amountToNumber(item.penaltyAmt || 0), 0);
      return [null, null, null, null, 'Totals', noOfRecords, null, null, amountFormat(taxAmt), null, amountFormat(penaltyAmt), amountFormat(totalFees), amountFormat(total)];
    },
    editedPaymentItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    reqdTaxTypeValidation() {
      return [
        (v) => !!v || 'Required',
      ];
    },
    errorMsgTaxYearTaxIdFunc() {
      const errList = this.errorMsgTaxYearTaxIdList;
      const errorMsgList = [];
      if (errList.length) {
        errList.map((ft) => {
          errorMsgList.push(`Tax Year: ${ft.taxYear}, Tax ID: ${ft.taxId} | `);
          return '';
        });
      }
      return errorMsgList.join('');
    },
    entireListErrorMessageText() {
      const allErrorMsg = [];
      // if ((this.editedItem.length - 1) === this.currentIndex) {
      if (this.statusCodeErrorList.length) {
        allErrorMsg.push({
          txtName: 'statusCodePayment',
          txtMsg: 'Multiple Records have a status code.',
        });
      }
      if (this.mtgCodeErrorList.length) {
        allErrorMsg.push({
          txtName: 'mtgPayment',
          txtMsg: 'Multiple Records have a mortgage code.',
        });
      }
      if (this.totalDueZeroErrorList.length) {
        allErrorMsg.push({
          txtName: 'alreadyPayExits',
          txtMsg: 'Multiple Records have no taxes due.',
        });
      }
      if (this.paymentExitsErrorList.length) {
        allErrorMsg.push({
          txtName: 'extraPayment',
          txtMsg: 'Multiple Records have pending payment',
        });
      }
      if (allErrorMsg.length) {
        allErrorMsg.push({
          txtName: 'defaultText',
          txtMsg: 'Do you wish to continue?',
        });
      }
      // }
      return allErrorMsg;
    },
  },
  methods: {
    getHeaders(showCert) {
      const useCert = showCert !== undefined
        ? showCert
        : ((this.paymentSettingItem || {}).showCertNumberOnPaymentScreen || false);
      return dialogTaxDetailsHeaders.map((h) => {
        if (h.value === 'reciept') {
          return useCert
            ? { ...h, text: 'Cert No', value: 'certNumber' }
            : h;
        }
        return h;
      });
    },
    toShortDate,
    amountFormat,
    propertyTaxTypeShortCode,
    ...mapMutations('base/crud', ['setIsVisible', 'setItem']),
    ...mapActions('tax/taxInquires', ['getTaxInquiryForPayment']),
    ...mapActions('tax/taxFee', [
      'loadTaxRollFeesTable',
      'upsertTaxFees',
    ]),
    ...mapActions('tax/taxPayment', [
      'generateMultipleReceipt',
      'loadPayment',
      'getPendingPaymentDetails',
    ]),
    //    ...mapActions('tax/taxComments', [
    //   'loadTaxComments',
    //   'upsertTaxCommentTrans',
    // ]),
    ...mapActions('tax/taxComments', [
      'upsertTaxCommentTrans', 'bulkUpsertComments',
    ]),
    // ...mapActions('tax/comments', [
    //   'bulkUpsertComments',
    // ]),
    ...mapActions('shared/taxReasonCode', [
      'loadReasonCode',
    ]),
    ...mapMutations('tax/taxPayment', [
      'setMinimizeTRToggleApiCalls',
      'setPaymentShotCutStore',
      'setIsThereAnyUnpaids',
    ]),
    ...mapActions(['flashWarn']),
    getCurrentTaxYear() {
      const getTaxYearStats = getTaxYearStatus();
      return getTaxYearStats.currentTax || null;
    },
    handleEnterKey(item, index) {
      console.info('Enter key intercepted on tax year field', { item, index });
    },
    getAlignment(column) {
      // Return alignment based on the column value
      const header = this.headers.find((h) => h.value === column);
      return header && header.align ? `text-${header.align}` : 'text-left';
    },
    checkDisableTax() {
      // eslint-disable-next-line max-len
      const onlyAdminsCanEditTaxAmount = (this.paymentSettingItem || {}).onlyAdminsCanEditTaxAmount || false;
      if (onlyAdminsCanEditTaxAmount && !(isAuthorised(authRoles.SuperAdmin)
       || isAuthorised(authRoles.TaxAdmin))) {
        return true;
      }
      return false;
    },
    // isHalfPayment(val, index) {
    //   setTimeout(() => {
    //     const currentItem = this.editedItem[index];
    //     const selTaxAmt = amountToNumber(currentItem.taxAmt);
    //     const selGrossAssessed = amountToNumber(currentItem.grossAssessed);
    //     if (val) {
    //       console.info('Half payment checked');
    //       currentItem.taxAmt = amountFormat(selTaxAmt / 2);
    //       currentItem.grossAssessed = amountToNumber(selGrossAssessed / 2);
    //     } else {
    //       currentItem.taxAmt = amountFormat(selTaxAmt * 2);
    //       currentItem.grossAssessed = amountToNumber(selGrossAssessed * 2);
    //     }
    //     this.calculateTotalDue(index);
    //     this.somethingChanged();
    //   }, 100);
    // },
    isHalfPayment(val, index) {
      setTimeout(() => {
        const currentItem = this.editedItem[index];
        // check half payment already done or not

        // Use stored original values, or current values if not yet stored
        let originalTaxAmt = 0;
        //  if (amountToNumber(currentItem.initialTaxAmt) === amountToNumber(currentItem.totalTax))
        if (amountToNumber(currentItem.taxAmt) === amountToNumber(currentItem.totalTax)) {
          originalTaxAmt = amountToNumber(currentItem.taxAmt);
        } else {
          originalTaxAmt = amountToNumber(currentItem.totalTax);
        }
        // originalTaxAmt = currentItem.originalTaxAmt || amountToNumber(currentItem.taxAmt);
        const originalGrossAssessed = currentItem.originalGrossAssessed
        || amountToNumber(currentItem.grossAssessed);

        // Store original values if not already stored (first time Half is clicked)
        // if (!currentItem.originalTaxAmt) {
        currentItem.originalTaxAmt = originalTaxAmt;
        currentItem.originalGrossAssessed = originalGrossAssessed;
        // }

        if (val) {
          currentItem.taxAmt = amountFormat(currentItem.originalTaxAmt / 2);
          currentItem.grossAssessed = currentItem.originalGrossAssessed / 2;
        } else {
          // if (amountToNumber(currentItem.originalTaxAmt)
          // === amountToNumber(currentItem.totalTax)) {
          //   originalTaxAmt = amountToNumber(currentItem.totalTax);
          // } else {
          // originalTaxAmt = amountToNumber(currentItem.taxAmt);
          // }
          originalTaxAmt = amountToNumber(currentItem.initialTaxAmt);
          // currentItem.originalTaxAmt = originalTaxAmt;
          currentItem.taxAmt = amountFormat(originalTaxAmt);
          currentItem.grossAssessed = currentItem.originalGrossAssessed;
        }
        this.calculateTotalDue(index);
        this.somethingChanged();
      }, 100);
    },
    onTypeClick() {
      this.taxType = this.statusTypes.map((el, index) => ({
        label: `${index + 1} ${el.description}`,
        value: el.name,
      }));
    },
    onTypeChange() {
      this.taxType = this.statusTypes.map((el, index) => ({
        label: index + 1,
        value: el.name,
      }));
    },
    addOne() {
      this.setMinimizeTRToggleApiCalls(null);
      const newId = this.defaultId + 1;
      this.defaultId = newId;
      // this.setItem([this.baseCrudKey, newItem]);
      this.$emit('input', [
        ...this.editedItem,
        {
          ...this.defaultItem,
          _id: newId,
          taxType: 'TAXPAYMENT',
          taxYear: this.defaultTaxYearFromTaxSetting || this.latestTaxYear || 0,
        },
      ]);
      return true;
    },
    /**
     * A row the clerk asked for - the '+' button or the Ins / F11 shortcut. Only the cursor
     * differs from addOne: with the Parcel ID setting on the row autofocus is off, so the new
     * row's Tax Yr field has to be focused here to keep that path usable.
     */
    addOneFromUser() {
      const added = this.addOne();
      this.focusLastTaxYear();
      return added;
    },
    /**
     * The '+' button specifically. Opening a fresh row means the clerk is done with the ones
     * already staged, so commit those first - ADD TO LIST is hidden now, and this is the
     * natural moment. Deliberately NOT folded into addOneFromUser: that is also reached from
     * the barcode scanner and the Ins / F11 shortcut, which stage rows differently.
     * The blank row this appends cannot be committed by mistake - addToList requires
     * taxYear + taxId + ownerName, so an empty row fails its filter.
     */
    addOneFromPlusButton() {
      const added = this.addOneFromUser();
      this.$emit('commitStagedTaxRows');
      return added;
    },
    // Puts the cursor in the Parcel ID lookup when the setting asks for it. Deferred like the
    // taxIdRef focus below: the dialog transition, the row autofocus and the payment details
    // '+' autofocus all reach for the cursor while the dialog is opening.
    focusParcelLookup() {
      if (!this.defaultCursorToParcelID) return;
      setTimeout(() => {
        if (this.$refs && this.$refs.parcelLookupRef) {
          this.$refs.parcelLookupRef.focus();
        }
      }, 100);
    },
    // addOne appends, so the row just added is the last one. Only needed while the Parcel ID
    // setting has the per-row autofocus switched off - otherwise autofocus already did this.
    focusLastTaxYear() {
      if (!this.defaultCursorToParcelID) return;
      setTimeout(() => {
        const { taxYearRef } = this.$refs || {};
        if (!taxYearRef) return;
        // the ref sits in a data-table item slot rather than a literal v-for, so Vue hands back
        // the row that registered last instead of the row list. Either way it is the appended row.
        const lastField = Array.isArray(taxYearRef)
          ? taxYearRef[taxYearRef.length - 1]
          : taxYearRef;
        if (lastField && lastField.focus) lastField.focus();
      }, 100);
    },
    // async getReceiptNumber(item, index) {
    //   const selectItem = { ...item };
    //   const selTaxYear = selectItem.taxYear;
    //   if (selTaxYear !== null) {
    //     const recNumber = await this.generateMultipleReceipt({ taxYear: [selTaxYear] });
    //     const receiptNumber = recNumber.length ? recNumber[0].maxReceipt + 1 : 1;
    //     this.receiptNumberLocalCounter[selTaxYear] = receiptNumber;
    //     this.editedItem[index].reciept = receiptNumber;
    //   }
    // },
    removeOne(item) {
      this.$emit('input', [
        ...this.editedItem.filter((candidate) => item !== candidate),
      ]);
    },
    somethingChanged() {
      this.$emit('input', this.editedItem);
    },
    sortTaxRecords() {
      this.editedItem.sort((a, b) => {
        // Convert taxId to number for consistent comparison
        const taxIdA = Number(a.taxId);
        const taxIdB = Number(b.taxId);

        // First group by tax ID
        if (taxIdA !== taxIdB) {
          return taxIdA - taxIdB; // Group same tax IDs together
        }
        // Within each tax ID group, sort by tax year in ascending order
        return a.taxYear - b.taxYear; // Ascending order for tax year
      });
    },
    async openFeesEditDialog(item, index) {
      const itemData = this.editedItem[index];
      this.selTaxDet = itemData;
      const itemAmtFormat = [];
      // Create backup of original fees for cancel functionality
      this.originalFeesBackup = JSON.parse(JSON.stringify(itemData.fees || []));
      // formatting to decimals
      for (let i = 0; i < (itemData.fees || []).length; i += 1) {
        const selFeeRec = { ...itemData.fees[i] };
        selFeeRec.feeAmount = amountFormat(selFeeRec.feeAmount);
        // Add feeCreatedAtpayment flag as false for existing fees
        selFeeRec.feeCreatedAtpayment = selFeeRec.feeCreatedAtpayment || false;
        itemAmtFormat.push(selFeeRec);
      }
      this.feeseditDialog = itemAmtFormat;
      this.feeDetailsIndex = index;
      this.$nextTick(() => {
        this.editFeesDialog = true;
      });
    },
    closeEditDialog() {
      // Restore original fees on cancel
      if (this.originalFeesBackup.length >= 0) {
        const restoredFees = JSON.parse(JSON.stringify(this.originalFeesBackup));
        this.editedItem[this.feeDetailsIndex].fees = restoredFees;
        // Recalculate totals with original fees
        const totalFees = this.originalFeesBackup.reduce((acc, fee) => (
          acc + amountToNumber(fee.feeAmount)
        ), 0);
        this.editedItem[this.feeDetailsIndex].totalFees = amountFormat(totalFees);
        this.calculateTotalDue(this.feeDetailsIndex);
        this.somethingChanged();
      }
      this.editFeesDialog = false;
      this.originalFeesBackup = [];
    },
    handleFeesItems(feesItem) {
      // Validate fees before saving
      const invalidFees = feesItem.filter((fee) => !fee.feeNumber || !fee.feeAmount);
      if (invalidFees.length > 0) {
        this.flashWarn('Please fill in all fee numbers and amounts');
        return;
      }

      // Format fees for saving - only include fields defined in feeDetailsInputField
      const formattedFees = feesItem.map((fee) => ({
        feeNumber: fee.feeNumber,
        feeDescription: fee.feeDescription,
        feeAmount: amountToNumber(fee.feeAmount),
        feeCreatedAtpayment: fee.feeCreatedAtpayment || false,
        feeMongoId: fee.feeMongoId || null,
      }));

      // Update the current item's fees
      this.editedItem[this.feeDetailsIndex].fees = formattedFees;

      // Calculate total fees
      const totalFees = feesItem.reduce((acc, item) => acc + amountToNumber(item.feeAmount), 0);
      this.editedItem[this.feeDetailsIndex].totalFees = amountFormat(totalFees);

      // Create an audit record for any fee that was added, deleted, or changed
      this.handleManualChanges(this.feeDetailsIndex, this.editedItem[this.feeDetailsIndex]);

      // Update totals and close dialog
      this.calculateTotalDue(this.feeDetailsIndex);
      // `editedItem` is a deep clone of the `value` prop, so everything above this point has
      // only touched a copy. Without this emit the saved fees never reach the payment - the
      // row total and Total Due keep the pre-edit figures, and Cancel (closeEditDialog) ends
      // up being the only one of the two buttons that tells the parent anything.
      this.somethingChanged();
      this.selTaxDet = {};
      this.editFeesDialog = false;
      this.originalFeesBackup = [];
    },
    async toggleExpand(item, ind) {
      if (this.minimizeTRToggleApiCalls !== ind) {
        const criteria = {
          taxYear: amountToNumber(item.taxYear),
        };
        // will be storing pId in taxId itself, so v-text-field wont need any changes
        const taxIdString = (item.taxId || '').toString();
        if (taxIdString && (taxIdString || []).length <= 7) {
          criteria.taxId = amountToNumber(item.taxId);
        } else if (taxIdString && (taxIdString || []).length > 7) {
          const removedHypens = taxIdString.replace(/-/g, '');
          criteria.pIdExactMatch = removedHypens;
        }
        if (Object.keys(criteria).length > 0 && criteria.taxYear
        && (criteria.taxId || criteria.pIdExactMatch)) {
          const ownerDetails = await this.getTaxInquiryForPayment({ criteria });
          this.setMinimizeTRToggleApiCalls(ind);
          // A parcel can resolve to several records for the same year (e.g. real
          // estate + special assessment sharing one baseId) — the unpaid scan must
          // still run or "Add All Unpaids" never offers the other unpaid records.
          const baseIds = [...new Set((ownerDetails || []).map((od) => (od ? od.baseId : undefined)))];
          if ((ownerDetails || []).length >= 1 && baseIds.length === 1 && baseIds[0] != null) {
            this.ownerInfo = ownerDetails;
            this.getUnpaidTaxes(ownerDetails[0]);
          }
        } else {
          this.setMinimizeTRToggleApiCalls(null);
          this.ownerInfo = [];
        }
        const isExpanded = this.expanded.includes(item);
        this.expanded = [];
        if (!isExpanded) {
          this.expanded.push(item);
        }
      }
    },
    async getUnpaidTaxes(item, triggerAddUnapaid = false, isFromOnBlur = false) {
      if (!item) { return; }
      const criteria = {
        baseId: item.baseId,
        unpaids: true,
      };
      const fetchedTaxData = await this.getTaxInquiryForPayment({ criteria });
      const backTaxesArr = [];
      const items = [...this.editedItem];
      if ((fetchedTaxData || []).length) {
        for (let i = 0; i < (fetchedTaxData || []).length; i += 1) {
          const taxEle = fetchedTaxData[i];
          const checkIfItsThereInEditItem = items.filter((ft) => ft.taxInquiryId === taxEle._id);
          if (!checkIfItsThereInEditItem.length) {
            backTaxesArr.push(taxEle);
          }
        }
      }

      this.paymentTaxes = backTaxesArr;
      if (backTaxesArr.length) {
        this.setIsThereAnyUnpaids(true);
        if (triggerAddUnapaid) {
          await this.addUnpaidTaxes();
          if (isFromOnBlur) {
            this.addOne();
          }
          this.setErrorList(item);
        }
      } else if (!triggerAddUnapaid) this.setIsThereAnyUnpaids(false);
    },
    setErrorList(item) {
      // this is called when there is and error text in allMessageText
      for (const textObj of (this.allMessageText || [])) {
        if (textObj.txtName === 'statusCodePayment') this.statusCodeErrorList.push('statusCodePayment');
        if (textObj.txtName === 'mtgPayment') this.mtgCodeErrorList.push('mtgPayment');
        if (textObj.txtName === 'alreadyPayExits') this.totalDueZeroErrorList.push('alreadyPayExits');
        if (textObj.txtName === 'extraPayment') this.paymentExitsErrorList.push('extraPayment');
      }
      const { taxYear, taxId } = item;
      if (this.allMessageText.length) {
        this.showOrHidePopUpForAllMsg = true;
        this.errorMsgTaxYearTaxIdList.push({ taxYear, taxId });
      }
      this.allMessageText = [];
    },
    addComments() {
      // Reset comment data to default values
      this.commentData = {
        category: 7, // Default category for user comments
        reasonCode: null,
        addToLegal: false,
        sendToWebsite: false,
        rollToNextYear: false,
        comment: '',
      };
      this.commentDialog = true;
    },
    async handleBulkCommentSave() {
      if (!this.commentData.comment || !this.commentData.comment.trim()) {
        this.flashWarn('Please enter a comment');
        return;
      }

      // Prepare bulk comment data for all tax records
      const taxRecords = this.editedItem.filter((item) => item.taxYear && item.taxId);

      if (taxRecords.length === 0) {
        this.flashWarn('No valid tax records found to add comments');
        return;
      }

      try {
        // Create comment entries for each tax record
        const commentEntries = taxRecords.map((taxRecord) => ({
          taxYear: amountToNumber(taxRecord.taxYear),
          taxId: amountToNumber(taxRecord.taxId),
          category: this.commentData.category,
          reasonCode: this.commentData.reasonCode,
          addToLegal: this.commentData.addToLegal,
          sendToWebsite: this.commentData.sendToWebsite,
          rollToNextYear: this.commentData.rollToNextYear,
          comment: this.commentData.comment,
          userName: this.userName,
          taxInquiryTransaction: taxRecord.taxInquiryId,
        }));
        await this.bulkUpsertComments({ item: commentEntries });

        this.commentDialog = false;
        // Reset comment data
        this.commentData = {
          category: 7,
          reasonCode: null,
          addToLegal: false,
          sendToWebsite: false,
          rollToNextYear: false,
          comment: '',
        };
      } catch (error) {
        console.error('Error saving bulk comments:', error);
        this.flashWarn('There was a problem saving the comments');
      }
    },
    closeCommentDialog() {
      this.commentDialog = false;
      // Reset comment data
      this.commentData = {
        category: 7,
        reasonCode: null,
        addToLegal: false,
        sendToWebsite: false,
        rollToNextYear: false,
        comment: '',
      };
    },
    // Parcel IDs are stored uppercase with no hyphens; normalize the keyed value to that form so
    // lower case, hyphens and stray whitespace all resolve to the same record set.
    normalizeParcelId(rawValue) {
      return (rawValue || '').toString().replace(/[\s-]/g, '').toUpperCase();
    },
    // Typing drives the lookup - it fires once the user pauses, same debounce the tax search
    // criteria fields use. A miss stays silent on this path: the partial parcel keyed on the way
    // to the full one is not an error worth flashing. Enter and leaving the field still run the
    // lookup at once (and report a miss), so nobody has to wait out the timer.
    parcelLookupByTimeOut() {
      clearTimeout(this.parcelLookupTimerId);
      this.parcelLookupTimerId = setTimeout(() => {
        this.loadUnpaidsByParcelId({ silentWhenMissing: true });
      }, SEARCH_DEBOUNCE_TIMER);
    },
    /**
     * Parcel ID field above the rows. Lookup control only - the value is never stored on the
     * payment; it just resolves the parcel to its unpaid tax records and loads all of them as
     * rows, then clears itself.
     * Every year with a balance is pulled, which is what "Add All Unpaids" already does for a
     * baseId (getUnpaidTaxes sends no taxYear). This runs regardless of the
     * loadUnpaidsAutomatically setting - loading is the whole point of the field.
     */
    async loadUnpaidsByParcelId({ silentWhenMissing = false } = {}) {
      // an explicit enter / blur wins over a lookup the debounce still has queued
      clearTimeout(this.parcelLookupTimerId);
      const parcelId = this.normalizeParcelId(this.parcelLookupId);
      // guards a blur straight after the enter key or the debounce already fired (the field is
      // cleared by then) and a re-entry while the first lookup is still in flight
      if (!parcelId || this.parcelLookupLoading) return;
      this.parcelLookupLoading = true;
      try {
        const unpaidRecords = await this.getTaxInquiryForPayment({
          criteria: { pIdExactMatch: parcelId, unpaids: true },
        }) || [];
        if (!unpaidRecords.length) {
          // the debounced path skips the existence check too - no second query per keystroke
          if (!silentWhenMissing) await this.flashNothingToLoadForParcel(parcelId);
          return;
        }
        // Honor the duplicate guard postUpdateEditedItem applies to keyed rows: a tax record
        // already on the payment must not be silently added a second time. taxInquiryId covers
        // resolved rows, taxYear+taxId covers rows keyed but not looked up yet.
        const alreadyOnPayment = (rec) => this.editedItem.some((row) => (
          (row.taxInquiryId && row.taxInquiryId === rec._id)
          || (Number(row.taxYear) === Number(rec.taxYear)
            && Number(row.taxId) === Number(rec.taxId))));
        const recordsToLoad = unpaidRecords.filter((rec) => !alreadyOnPayment(rec));
        if (!recordsToLoad.length) {
          this.flashWarn(`Parcel ${parcelId}: all unpaid records are already on this payment`);
          return;
        }
        // the lookup carries no sort of its own - oldest year first, then tax id
        recordsToLoad.sort((recA, recB) => (Number(recA.taxYear) - Number(recB.taxYear))
          || (Number(recA.taxId) - Number(recB.taxId)));
        const skippedCount = unpaidRecords.length - recordsToLoad.length;
        if (skippedCount) {
          this.flashWarn(`Parcel ${parcelId}: ${skippedCount} unpaid record(s) already on this payment were skipped`);
        }
        // the parcel's records fill the empty keyed rows (a new payment opens with one, and one
        // is left behind after every load) rather than stacking underneath them
        if (this.dropBlankPaymentRows()) await this.$nextTick();
        // ownerInfo feeds the Mtg Code / "Other Taxes Due" labels; addUnpaidTaxes consumes
        // paymentTaxes, exactly as the "Add All Unpaids" button does
        this.ownerInfo = unpaidRecords;
        this.paymentTaxes = recordsToLoad;
        this.parcelLookupId = '';
        await this.addUnpaidTaxes('fromBtnClick');
      } catch (warn) {
        console.warn('Warning: Something unexpected occurred in loadUnpaidsByParcelId', warn);
      } finally {
        this.parcelLookupLoading = false;
      }
    },
    /**
     * Drops the keyed rows nothing was ever entered on, so a load can take their place. addOne
     * leaves one behind on open and after every load, and it is the clerk who would otherwise
     * have to delete it. Only rows still marked new are touched - a row that came off a saved
     * payment stays put whatever it holds. Returns whether anything was dropped, since the
     * caller has to wait a tick for the emit to come back down as the prop.
     */
    dropBlankPaymentRows() {
      const isBlankRow = (row) => row.itsNewRecord && !row.posted && !row.void
        && !row.taxId && !row.taxInquiryId
        && !amountToNumber(row.taxAmt) && !amountToNumber(row.total)
        && !(row.fees || []).length;
      const keptRows = this.editedItem.filter((row) => !isBlankRow(row));
      if (keptRows.length === this.editedItem.length) return false;
      this.$emit('input', keptRows);
      return true;
    },
    // Nothing was loaded - say which case it is. The existence check is one record with ids only,
    // and runs only on this path, so the common case stays a single query.
    async flashNothingToLoadForParcel(parcelId) {
      const anyRecords = await this.getTaxInquiryForPayment({
        criteria: { pIdExactMatch: parcelId, limit: 1 },
        fields: { _id: '', taxYear: '' },
      }) || [];
      if (anyRecords.length) this.flashWarn(`Parcel ${parcelId} has no unpaid taxes`);
      else this.flashWarn(`Parcel ${parcelId} not found`);
    },
    async addUnpaidTaxes(fromWhere = '') {
      this.isUnpaidFlag = true;
      const length = this.editedItem.length ? this.editedItem.length : 0;
      const data = this.paymentTaxes;
      let calculateIndex = length;
      for (const item of data) {
        // to check for exiting records
        const checkExitingRecord = this.editedItem.filter((ft) => ft.taxInquiryId === item._id);
        if (!checkExitingRecord.length) {
          await this.addOne();
          const criteria = {
            taxYear: amountToNumber(item.taxYear),
            taxId: amountToNumber(item.taxId),
          };
          const initialVal = {
            taxYear: amountToNumber(item.taxYear),
            taxId: amountToNumber(item.taxId),
            itsNewRecord: true,
            isFromProtestOrPicklist: true,
          };
          // to add taxyear and taxid
          const currentItem = this.editedItem[calculateIndex];
          currentItem.taxYear = amountToNumber(item.taxYear);
          currentItem.taxId = amountToNumber(item.taxId);

          await this.commonLoadTaxInquiryFunc(initialVal,
            criteria, calculateIndex, item, [], true);
          calculateIndex += 1;
        }
      }
      setTimeout(async () => {
        this.isUnpaidFlag = false;
        if (fromWhere === 'fromBtnClick') {
          await this.addOne();
          // Tell the parent (LargePaymentList) the unpaid records finished loading, so it
          // can commit them via its "Add to List" function instead of leaving them pending.
          // If the load raised a warning modal, defer that until the clerk dismisses it -
          // maybeEmitUnpaidTaxesAdded holds off while showOrHidePopUpForAllMsg /
          // showPendingPaymentPopup is still open.
          this.awaitingUnpaidTaxesPopupClose = true;
          this.maybeEmitUnpaidTaxesAdded();
        }
      }, 1000);
    },
    async onVoidClick(val, index) {
      const currentItem = this.editedItem[index];
      currentItem.taxAmt = 0.00;
      currentItem.penaltyAmt = 0.00;
      currentItem.total = 0.00;
      currentItem.void = true;
      currentItem.fees = [];
      currentItem.totalFees = 0.00;
      // 'isItNewVoidedRecord' will allow us to mitigate compare with previous data in backend
      currentItem.isItNewVoidedRecord = true;
    },
    async onVoidChange(val, index) {
      const currentItem = this.editedItem[index];
      if (val) {
        currentItem.taxAmt = 0.00;
        currentItem.penaltyAmt = 0.00;
        currentItem.total = 0.00;
        currentItem.fees = [];
        currentItem.totalFees = 0.00;
        // 'isItNewVoidedRecord' will allow us to mitigate compare with previous data in backend
        currentItem.isItNewVoidedRecord = true;
      } else {
        const totalCaclAmt = amountToNumber(currentItem.initialTotalFees)
        + amountToNumber(currentItem.initialTaxAmt) + amountToNumber(currentItem.initialPenaltyAmt);
        currentItem.total = amountFormat(totalCaclAmt || 0);
        currentItem.taxAmt = amountFormat(currentItem.initialTaxAmt);
        currentItem.penaltyAmt = amountFormat(currentItem.initialPenaltyAmt);
        currentItem.fees = currentItem.initialFees;
        currentItem.totalFees = amountFormat(currentItem.initialTotalFees);
        // 'isItNewVoidedRecord' will allow us to mitigate compare with previous data in backend
        currentItem.isItNewVoidedRecord = false;
      }
      this.somethingChanged();
    },
    async fromOtherSourcesUpdateEditedItem() {
      if (this.editedItem.length) {
        for (let i = 0; i < (this.editedItem || []).length; i += 1) {
          const item = this.editedItem[i];
          // isFromOtherSources(means other than payment screen)
          if (item.isFromOtherSources) {
            if (item.isFromProtest || item.isExempt) await this.forExemptAndProtestFunc(item, i);
            // here passing the flag 'lastIndex' to trigger the unpaids
            else if ((i + 1) === this.editedItem.length) await this.commonUpdateEditedItem(item, i, 'lastIndex');
            else await this.commonUpdateEditedItem(item, i);
          }
        }
      } else this.addOne();
    },
    async preUpdateEditedItem(item, index, isFromOnBlur = false, immediate = false) {
      const selectedItem = this.editedItem[index];
      // isFromOtherSources(means other than payment screen)
      if (!selectedItem.isFromOtherSources) {
        if (selectedItem.AIsVisible) return;
        await this.postUpdateEditedItem(item, index, 'lastIndex', isFromOnBlur, immediate);
      }
    },
    // 'immediate' skips the keystroke debounce for callers that already hold a complete value -
    // a barcode scan. Manual typing still debounces, otherwise every digit of a hand-keyed tax
    // id would fire its own lookup.
    async postUpdateEditedItem(item, index, isItLastIndex = '', isFromOnBlur = false,
      immediate = false) {
      // this function trigger when dialog is open
      clearTimeout(this.updateTimer);
      if (immediate) {
        await this.commonUpdateEditedItem(item, index, isItLastIndex, isFromOnBlur);
        return;
      }
      this.updateTimer = setTimeout(async () => {
        await this.commonUpdateEditedItem(item, index, isItLastIndex, isFromOnBlur);
      }, 300);
    },
    // Hold a lookup that arrived while another one is in flight, so it can run when that one
    // finishes. Keyed by row: a row only ever needs its latest value looked up, but a scan of a
    // *different* statement must not displace one already waiting, or that row stays blank.
    queueLookup(entry) {
      const queued = this.pendingLookups.findIndex((pl) => pl.index === entry.index);
      if (queued === -1) this.pendingLookups.push(entry);
      else this.pendingLookups.splice(queued, 1, entry);
    },
    runNextLookup() {
      const next = this.pendingLookups.shift();
      if (!next) return;
      this.commonUpdateEditedItem(next.item, next.index, next.isItLastIndex, next.isFromOnBlur);
    },
    async commonUpdateEditedItem(item, index, isItLastIndex, isFromOnBlur = false) {
      // A scanner fires when the clerk pulls the trigger, not when we are ready for it. This
      // guard used to `return` outright, which lost the scan for good: the row stayed blank and
      // the clerk had to notice and re-scan ("you must hit insert again to continue scanning").
      // Queue it instead - nothing is dropped, and the clerk never has to wait on the wire.
      if (this.isProcessingUpdate) {
        this.queueLookup({
          item, index, isItLastIndex, isFromOnBlur,
        });
        return;
      }
      this.isProcessingUpdate = true;
      this.lookupLoadingIndex = index;
      // Backstop. isProcessingUpdate is released in the finally below, which only runs once the
      // request settles - and nothing in the GraphQL client bounds that (see
      // TAX_LOOKUP_TIMEOUT_MS). A request that hung therefore latched the guard on for the life
      // of the dialog, silently swallowing every later scan. Never let that happen.
      clearTimeout(this.lookupWatchdog);
      this.lookupWatchdog = setTimeout(() => {
        if (!this.isProcessingUpdate) return;
        console.warn('Tax lookup did not settle in time; releasing the in-flight guard');
        this.isProcessingUpdate = false;
        this.lookupLoadingIndex = -1;
        this.runNextLookup();
      }, TAX_LOOKUP_TIMEOUT_MS);

      try {
        this.currentIndex = index;
        if (!item.taxYear) {
          this.setPaymentShotCutStore({ res: true, whichOne: 'paymentAddIconStatus' });
        }
        this.setMinimizeTRToggleApiCalls(null);

        // to check is it taxId or pId
        const criteria = {
          taxYear: amountToNumber(item.taxYear),
        };

        // will be storing pId in taxId itself, so v-text-field wont need any changes
        const taxIdString = (item.taxId || '').toString();
        if (taxIdString && (taxIdString || []).length <= 7) {
          criteria.taxId = amountToNumber(item.taxId);
        } else if (taxIdString && (taxIdString || []).length > 7) {
          const removedHypens = taxIdString.replace(/-/g, '');
          criteria.pIdExactMatch = removedHypens;
        }
        // this will give us the difference and also stops the unwanted api calls
        const ifThereIsAnyChanges = checkObjPaymentsDiff(this.editedItem[index]);
        const isTaxYearNTaxIdEmpty = !!criteria.taxYear
        && (!!criteria.taxId || !!criteria.pIdExactMatch);

        if (Object.keys(criteria).length && isTaxYearNTaxIdEmpty && item.itsNewRecord
        && ifThereIsAnyChanges && !this.isUnpaidFlag) {
          // to reset paymentAddIconStatus to switch b/w adding payment or tax record
          this.setPaymentShotCutStore({ res: false, whichOne: 'paymentAddIconStatus' });

          // Abort rather than just abandoning it: the action already plumbs `signal` through to
          // fetchOptions, and a socket left open on a county's flaky link is what stalls the
          // next scan behind it.
          const lookupAbort = new AbortController();
          const abortAt = setTimeout(() => lookupAbort.abort(), TAX_LOOKUP_TIMEOUT_MS);
          let newData;
          try {
            newData = await this.getTaxInquiryForPayment({ criteria, signal: lookupAbort.signal });
          } finally {
            clearTimeout(abortAt);
          }

          if ((newData || []).length) {
            const firstData = newData[0];
            // calling payments api to get if this record exits or not
            const paymentCriteria = {
              taxYear: firstData.taxYear,
              taxId: firstData.taxId,
              fiscalYear: this.fiscalYear,
              void: false,
              posted: false,
            };
            const commonLoadTaxInquiryFuncCriteria = {
              taxYear: firstData.taxYear,
              taxId: firstData.taxId,
            };
            const checkTaxIdAndTaxYear = this.editedItem.filter(
              (ft, idx) => (idx !== index) && (Number(ft.taxYear) === Number(firstData.taxYear)
              && Number(ft.taxId) === Number(firstData.taxId)),
            );
            // to check if the tax id is already added for the selected tax year
            // even if the tax id is already added for the selected tax year
            // , we need to allow the user to add the payment
            if (checkTaxIdAndTaxYear.length) {
              const currentRoute = this.$route.path;
              if (!currentRoute.includes('protestedTax')) {
                this.duplicateTaxDetailIndex = index;
                this.duplicateTaxDetailData = {
                  firstData,
                  paymentCriteria,
                  commonLoadTaxInquiryFuncCriteria,
                  item,
                  isItLastIndex,
                  isFromOnBlur,
                };
                this.duplicateTaxDetailDialog = true;
                // The finally below releases the guard and drains the queue - this row is now
                // waiting on the clerk's answer, not on us.
                return;
              }
            }
            // } else {
            const retPayments = await this.loadPayment({ criteria: paymentCriteria });
            await this.commonLoadTaxInquiryFunc(item, commonLoadTaxInquiryFuncCriteria,
              index, firstData, retPayments, false, isItLastIndex, isFromOnBlur);
            this.addPaidByFunc(firstData);
            // }
          } else {
            // reset the tax-details values
            this.resetTaxRecord();
            this.flashWarn('Record with combination of taxyear and taxid not found');
            this.editedItem[index].taxId = '';
            setTimeout(() => {
              if (this.$refs && this.$refs.taxIdRef) {
                this.$refs.taxIdRef.focus();
              }
            }, 100);
          }

          this.somethingChanged(); // this to update the store
        }
      } catch (warn) {
        console.warn('Warning: Something unexpected occurred in postUpdateEditedItem', warn);
      } finally {
        clearTimeout(this.lookupWatchdog);
        this.isProcessingUpdate = false;
        this.lookupLoadingIndex = -1;
        this.runNextLookup();
      }
    },
    addPaidByFunc(data) {
      // check name and preFillPaymentWithOwnerName is true or present
      if (!data.name1 || !this.paymentSettingItem.preFillPaymentWithOwnerName) return;

      // The payment being built does not always live under THIS component's baseCrudKey. The
      // large-payment screen mounts this grid under 'largePaymentListAddNew' purely to stage
      // new rows, while the payment - and the Payment Info section bound to it - stays on
      // 'pickListMakePaymentDialog'. Writing Paid By to the staging key meant it never showed
      // up there. Same fallback commonLoadTaxInquiryFunc already uses for penaltyDate.
      const paymentCrudKey = this.baseCrudKey === 'largePaymentListAddNew'
        ? 'pickListMakePaymentDialog'
        : this.baseCrudKey;
      const paymentItem = this.item(paymentCrudKey) || {};
      const details = paymentItem.paymentDetails;

      // setItem rather than mutating in place: assigning a brand new paymentDetails property
      // onto the store object is invisible to Vue 2 reactivity, so the field stayed blank
      // until some unrelated re-render. Spreading keeps taxDetails on the same reference, so
      // lookups still writing into it are unaffected.
      if (!details || !details.length) {
        this.setItem([paymentCrudKey, {
          ...paymentItem,
          paymentDetails: [{ paymentType: '', amount: 0, paidBy: data.name1 }],
        }]);
        return;
      }
      // prefill only - never overwrite a Paid By the clerk already typed
      if (details[0].paidBy) return;
      this.setItem([paymentCrudKey, {
        ...paymentItem,
        paymentDetails: details.map((det, i) => (
          i === 0 ? { ...det, paidBy: data.name1 } : det
        )),
      }]);
    },
    async forExemptAndProtestFunc(item, index) {
      const currentItem = this.editedItem[index];
      const feeDetails = [];
      const feeAmt = 0;
      const returnedVal = { penaltyAmt: amountFormat(0) };

      currentItem.penaltyAmt = amountFormat(0);
      // currentItem.penaltyStartDate = penaltyStartDate;
      // currentItem.totalPaid = totalPaid;
      // currentItem.totalTax = totalTax;
      // currentItem.taxTotalDue = totalDue;
      currentItem.penaltyChangedManually = false;
      currentItem.totalFees = amountFormat(feeAmt);
      currentItem.taxAmt = amountFormat(currentItem.taxAmt);
      currentItem.fees = feeDetails;
      currentItem.isFromOtherSources = false;
      currentItem.isFromProtestOrPicklist = false;
      currentItem.schoolDistrict = item.schoolDistrict;
      currentItem.ownerName = item.ownerName;
      // calculate totalDue
      const totalCaclAmt = amountToNumber(returnedVal.penaltyAmt)
            + amountToNumber(currentItem.taxAmt) + amountToNumber(feeAmt);
      currentItem.total = amountFormat(totalCaclAmt || 0);

      if (item.itsNewRecord) {
        currentItem.initialPenaltyAmt = amountToNumber(returnedVal.penaltyAmt);
        currentItem.initialTaxAmt = amountToNumber(currentItem.taxAmt);
        currentItem.initialFees = feeDetails;
        currentItem.initialTotalFees = amountToNumber(feeAmt);
        currentItem.initialTaxYear = currentItem.taxYear;
        currentItem.initialTaxId = currentItem.taxId;
      }
    },
    async commonLoadTaxInquiryFunc(item, criteria, index, newData, retPayments = [],
      isItFromDelequientFunc = false, isItLastIndex = '', isFromOnBlur = false) {
      const currentItem = this.editedItem[index]; // get all tax inquiry data.
      const isAutomaticAddOn = (this.paymentSettingItem || {}).loadUnpaidsAutomatically || false;
      let flagForCheckAnyErrors = false;
      // get todays date or previos month date
      let penDate = toIsoDate(this.todaysDate);
      // if there is penalty date - force re-fetch from store to get latest value
      // Use a fresh call to item() getter instead of cached editedPaymentItem
      let freshPaymentItem = this.item(this.baseCrudKey);
      if (!freshPaymentItem.penaltyDate && this.baseCrudKey === 'largePaymentListAddNew') {
        freshPaymentItem = this.item('pickListMakePaymentDialog');
      }
      if (freshPaymentItem && freshPaymentItem.penaltyDate) {
        penDate = toIsoDate(
          freshPaymentItem.penaltyDate,
        );
      }
      // this if condition will override if there is any penaltyDate
      if (this.halfOrPostmark.dialogPostmark) {
        penDate = getPreviousPenaltyPeriodEnd(this.todaysDate, this.taxSettingItem.penaltyDate);
      }
      const {
        totalTax, totalPaid, penaltyStartDate, taxYear, totalDue, taxId, schoolDistrict, mtgCode,
        alertStatusCodes, land, improvements, mobileHome, exemptions, _id, baseId, assessorPenalty,
        statusCode, name1, name2, certificate,
      } = newData;

      // if status code is 406, then return 0 for penalty and also for fee
      const isExemptManufacturing = (statusCode || []).includes(exemptManufacturingStatusCode);

      // to get fees
      // Start from whatever fees the row is already carrying, not from empties. This
      // function can run more than once for the same row (e.g. a Tax Yr / Tax ID blur
      // after the Half checkbox has armed checkObjPaymentsDiff), and the assignments
      // further down write feeDetails / feeAmt onto the row unconditionally — so every
      // pass after the first used to zero the Fees column and drop the fees out of the
      // row total.
      // Preserved rather than re-loaded on purpose: fees added at payment time carry
      // 'feeCreatedAtpayment' and are not in taxFees yet, so a blind reload drops them.
      // feeAmt is re-derived from the array because the Fees field is readonly and the
      // array is the only source of truth (see openFeesEditDialog).
      let feeDetails = isExemptManufacturing ? [] : (item.fees || []);
      let feeAmt = feeDetails.reduce((acc, fee) => acc + amountToNumber(fee.feeAmount), 0);
      if ((!item.fees || !item.fees.length) && !isExemptManufacturing) {
        const feeData = await this.loadTaxRollFeesTable(
          { criteria: { ...criteria, paymentNotDone: true } },
        );
        if (feeData.length) {
          currentItem.allFeesList = feeData;
          const { feeDet, feesAmt } = getFeeListBasedOnEffeciveDate(feeData, penDate);
          feeDetails = feeDet;
          feeAmt = feesAmt;
        }
      }

      // this is for resale only — apply fee to the first matching record only
      if (taxYear === (this.selectedComponentCriteria || {}).oldTaxYear) {
        if ((this.selectedComponentCriteria || {}).resaleFeeAmount
          && !this.resaleFeeApplied) {
          const feeResale = resaleExcessUnit;
          const filteredTaxMasterList = (this.taxFeeMasterData || [])
            .filter((ft) => (ft.toUnit || '').toLowerCase() === feeResale);
          const feeDescription = filteredTaxMasterList.length > 0 ? filteredTaxMasterList[0].feeDescription : '';
          const feeNum = filteredTaxMasterList.length > 0 ? filteredTaxMasterList[0].feeNumber : '';
          const feeForResaleList = {
            feeAmount: this.selectedComponentCriteria.resaleFeeAmount || 0,
            feeDescription,
            feeNumber: feeNum,
            feeCreatedAtpayment: true,
          };

          feeDetails = [...feeDetails, feeForResaleList];
          feeAmt = feeAmt + this.selectedComponentCriteria.resaleFeeAmount || 0;
          this.resaleFeeApplied = true;
        }
      }

      let returnedVal = { penaltyAmt: amountFormat(0) };
      // to get penaltyAmt
      const { penaltyDate, penaltyRate } = this.taxSettingItem;
      const penaltyEndDate = toShortDate(penDate);
      const penStartDate = toShortDate(penaltyStartDate);
      returnedVal = penaltyCalculation(
        penaltyEndDate, penStartDate, penaltyDate, totalTax,
        totalPaid, 0, penaltyRate, totalDue, taxYear, (statusCode || []), this.taxSettingItem,
      );

      // to disable tax amount for back taxes
      const taxStatus = getTaxYearStatus();
      currentItem.allowBackTaxEdit = false;
      if (amountToNumber(taxYear) <= amountToNumber(taxStatus.backTax)) {
        if (this.paymentSettingItem.allowPartialPayemnts) {
          currentItem.allowBackTaxEdit = false;
        } else currentItem.allowBackTaxEdit = true;
      }

      let returnedPenaltyAmt = returnedVal.penaltyAmt;
      // if it is from June resale, then we need to set the penaltyAmt to the current penalty
      if (this.isItFromJuneResale) {
        returnedPenaltyAmt = item.penaltyAmt;
      }
      currentItem.penaltyAmt = amountFormat(amountToNumber(returnedPenaltyAmt));
      currentItem.penaltyStartDate = penaltyStartDate;
      currentItem.totalPaid = totalPaid;
      currentItem.totalTax = totalTax;
      currentItem.baseId = baseId;
      currentItem.taxTotalDue = totalDue;
      currentItem.penaltyChangedManually = false;
      currentItem.ownerName = `${name1 || ''} ${name2 || ''}`;
      currentItem.schoolDistrict = schoolDistrict;
      // the roll record's taxType is the property tax type (R/P/B/...) the Tax Type column shows;
      // $set because the row object is built without this key
      this.$set(currentItem, 'propertyTaxType', newData.taxType);
      currentItem.totalFees = isExemptManufacturing ? 0 : amountFormat(feeAmt);
      currentItem.statusCode = isExemptManufacturing ? [exemptManufacturingStatusCode] : [];
      currentItem.fees = feeDetails;
      currentItem.exemptions = exemptions;
      // eslint-disable-next-line max-len
      // const totalGrossAssessed = (land || 0) + (improvements || 0) + (mobileHome || 0) + (assessorPenalty || 0);
      // currentItem.grossAssessed = totalGrossAssessed;
      // currentItem.mtgCode = mtgCode;
      // currentItem.taxInquiryId = _id;
      // currentItem.originalTaxId = taxId; // this is used for only for when searched bu PID
      // currentItem.mobileHome = mobileHome; // this is for open the dialog for decal number

      // // check for half or full pay, checking for penalty and fees
      // let taxAmtVal = 0;
      // taxAmtVal = amountFormat(newData.totalDue);
      // if (this.halfOrPostmark.dialogHalf && !returnedVal.penaltyAmt && !feeAmt) {
      //   taxAmtVal = amountFormat(newData.totalDue / 2);
      //   currentItem.Half = true;
      //   currentItem.disableHalf = false;
      // } else if (returnedVal.penaltyAmt || feeAmt) {
      //   currentItem.Half = false;
      //   currentItem.disableHalf = true;
      // }
      // // for exempt payment
      // currentItem.taxAmt = taxAmtVal;
      const totalGrossAssessed = (land || 0) + (improvements || 0) + (mobileHome || 0)
      + (assessorPenalty || 0);
      currentItem.mtgCode = mtgCode;
      currentItem.taxInquiryId = _id;
      currentItem.originalTaxId = taxId; // this is used for only for when searched bu PID
      currentItem.mobileHome = mobileHome; // this is for open the dialog for decal number
      currentItem.certNumber = certificate || null;

      // Store original values BEFORE any half calculations
      currentItem.originalTaxAmt = amountToNumber(newData.totalTax);
      currentItem.originalGrossAssessed = totalGrossAssessed;

      // Preserve Half checkbox state if it exists
      const isHalfChecked = currentItem.Half || false;

      // check for half or full pay, checking for penalty and fees
      let taxAmtVal = 0;
      taxAmtVal = amountFormat(newData.totalDue);

      // Branch order below is DELIBERATE — do not reorder.
      // 'allowPartialPayemnts' is a per-county opt-in, and it intentionally takes
      // precedence over the penalty/fee/special-assessment gate in the next branch. A
      // county that has opted in wants Half available on delinquents, fee-bearing ones
      // included (Washington relies on this), so the county's opt-in is what wins.
      // Consequence: a row with fees keeps disableHalf = false while the setting is on,
      // and only falls through to the gate below when the setting is off. Reordering
      // these two branches would take the Half checkbox away from opted-in counties on
      // exactly the records they need it for.
      // 1. setting on + totalDue >= MIN_ALLOW_AMT_HALF + not a special assessment
      //    -> Half allowed, penalty and fees ignored
      // 2. otherwise penalty / fees / special assessment / at-or-under the minimum
      //    -> Half disabled
      if (this.paymentSettingItem.allowPartialPayemnts && newData.totalDue >= MIN_ALLOW_AMT_HALF && newData.taxType !== 'S') {
        taxAmtVal = amountFormat(newData.totalDue);
        currentItem.Half = false;
        currentItem.disableHalf = false;
        currentItem.grossAssessed = currentItem.originalGrossAssessed;
      } else if (returnedPenaltyAmt || feeAmt || (newData.taxType === 'S' || newData.totalDue <= MIN_ALLOW_AMT_HALF)) {
        // If there are penalties or fees, disable half payment
        taxAmtVal = amountFormat(newData.totalDue);
        currentItem.Half = false;
        currentItem.disableHalf = true;
        currentItem.grossAssessed = currentItem.originalGrossAssessed;
      } else if (isHalfChecked || this.halfOrPostmark.dialogHalf) {
        // Only allow half if no penalties/fees AND (Half was checked OR dialogHalf is enabled)
        taxAmtVal = amountFormat(currentItem.originalTaxAmt / 2);
        currentItem.Half = true;
        currentItem.disableHalf = false;
        currentItem.grossAssessed = currentItem.originalGrossAssessed / 2;
      } else {
        // Full payment - set to original values
        taxAmtVal = amountFormat(newData.totalDue);
        currentItem.grossAssessed = currentItem.originalGrossAssessed;
      }

      // for exempt payment
      currentItem.taxAmt = taxAmtVal;

      // calculate totalDue
      const totalCaclAmt = amountToNumber(returnedPenaltyAmt)
      + amountToNumber(taxAmtVal) + amountToNumber(feeAmt);
      currentItem.total = amountFormat(totalCaclAmt || 0);

      // Status code popup
      if ((alertStatusCodes || []).length) {
        if (!item.isFromProtestOrPicklist) {
          this.showOrHidePopUpForAllMsg = true;
          this.allMessageText.push({
            txtName: 'statusCodePayment',
            txtMsg: `This record has a status code of ${alertStatusCodes}.`,
          });
        } else {
          // 416/419 (Pending Payment / Pending Web Payment) get their own popup with the
          // actual payment number/date, instead of being swallowed into the generic
          // 'Multiple Records have a status code.' message.
          const { pendingCodes, otherCodes } = partitionPendingPaymentAlertCodes(
            alertStatusCodes,
          );
          if (pendingCodes.length) {
            const pendingDetails = await this.getPendingPaymentDetails({
              criteria: { pairs: [{ taxYear, taxId }] },
            });
            if ((pendingDetails || []).length) {
              pendingDetails.forEach((detail) => {
                this.pendingPaymentList.push({
                  taxYear, taxId, paymentNumber: detail.paymentNumber, payDate: detail.payDate,
                });
              });
              this.showPendingPaymentPopup = true;
            } else {
              // stale flag: no pending payment behind it after all - fall through
              // to the generic status-code popup instead of a blank row
              otherCodes.push(...pendingCodes);
            }
          }
          if (otherCodes.length) {
            this.showOrHidePopUpForAllMsg = true;
            this.statusCodeErrorList.push(otherCodes);
            flagForCheckAnyErrors = true;
          }
        }
      }

      // mtg code popup
      if (this.paymentSettingItem.warnWhenPayingRecWithMtg) {
        if (mtgCode) {
          this.showOrHidePopUpForAllMsg = true;
          if (!item.isFromProtestOrPicklist) {
            this.allMessageText.push({
              txtName: 'mtgPayment',
              txtMsg: `Tax Yr ${taxYear} Tax ID ${taxId} is coded with the mortgage code ${mtgCode}.`,
            });
          } else {
            this.mtgCodeErrorList.push(mtgCode);
            flagForCheckAnyErrors = true;
          }
        }
      }

      // to open dialog is taxDue is 0
      if (!newData.totalDue) {
        this.showOrHidePopUpForAllMsg = true;
        if (!item.isFromProtestOrPicklist) {
          this.allMessageText.push({
            txtName: 'alreadyPayExits',
            txtMsg: 'This record has no taxes due.',
          });
        } else {
          this.totalDueZeroErrorList.push(taxId);
          flagForCheckAnyErrors = true;
        }
      }

      // this is to highlight the back-ground with red color
      if (retPayments.length) {
        const firstArr = retPayments[0];
        const payDate = firstArr.payDate ? toShortDate(firstArr.payDate) : '';
        const paymentNumber = firstArr.paymentNumber || '';
        const workstation = firstArr.workstation || '';
        currentItem.thereIsAPrevUnptRec = true;
        this.showOrHidePopUpForAllMsg = true;
        if (!item.isFromProtestOrPicklist) {
          this.allMessageText.push({
            txtName: 'extraPayment',
            txtMsg: `There is a pending payment on this tax record:
      Date: ${payDate}, Payment#: ${paymentNumber}, Wkst#: ${workstation} for $${amountFormat(totalDue)}.`,
          });
        } else {
          this.paymentExitsErrorList.push(paymentNumber);
          flagForCheckAnyErrors = true;
        }
      } else currentItem.thereIsAPrevUnptRec = false;

      if (this.allMessageText.length && !item.isFromProtestOrPicklist) {
        this.errorMsgTaxYearTaxId = `Tax Year: ${taxYear}, Tax ID: ${taxId}`;
        this.allMessageText.push({
          txtName: 'defaultText',
          txtMsg: 'Do you wish to continue?',
        });
      }

      if (flagForCheckAnyErrors) this.errorMsgTaxYearTaxIdList.push({ taxYear, taxId });

      // for audit record
      if (item.itsNewRecord) {
        currentItem.initialPenaltyAmt = amountToNumber(returnedPenaltyAmt);
        currentItem.initialTaxAmt = amountToNumber(taxAmtVal);
        currentItem.initialFees = feeDetails;
        currentItem.initialTotalFees = amountToNumber(feeAmt);
        currentItem.initialTaxYear = taxYear;
        currentItem.initialTaxId = taxId;
      }

      if (!this.allMessageText.length) this.commonAddOneForScanner();
      currentItem.isFromOtherSources = false;
      currentItem.isFromProtestOrPicklist = false;

      // To add delinquent taxes automatically - for the record that just arrived, and only that
      // one. Both ways of keying a record land here: the Tax Yr / Tax ID blur (isFromOnBlur) and
      // the barcode scanner, which reaches preUpdateEditedItem without that flag. The barcode
      // path used to go through getAllUnPaids, which ignored its arguments and re-scanned every
      // row on the payment - one query per row, so each scan cost more than the one before it on
      // a payment that was still growing. Nothing needed the re-scan: a row already on the
      // payment has had its parcel asked about, and getUnpaidTaxes filters out what is already
      // there. isFromOnBlur is still passed through because it is what decides whether a fresh
      // empty row is opened afterwards (addOne).
      if (isAutomaticAddOn && !isItFromDelequientFunc && isItLastIndex === 'lastIndex') {
        this.getUnpaidTaxes(newData, true, isFromOnBlur);
      }

      // to update the main items
      this.editedItem[index] = currentItem;

      // if its only from payment dialog, when they eneter taxyear and taxid manually
      this.toggleExpand(item, index);
      this.somethingChanged();
      return currentItem;
    },
    resetTaxRecord() {
      const currentItem = this.editedItem[this.currentIndex];
      currentItem.schoolDistrict = '';
      currentItem.taxAmt = null;
      // currentItem.reciept = null;
      currentItem.penaltyAmt = null;
      currentItem.total = null;
      currentItem.itsNewRecord = true;
      currentItem.totalPaid = null;
      currentItem.totalTax = null;
      currentItem.taxTotalDue = null;
      currentItem.totalFees = null;
      currentItem.fees = [];
      delete currentItem.grossAssessed;
      this.somethingChanged();
    },
    resetOnCancel() {
      const currentItem = this.editedItem[this.currentIndex];
      this.removeOne(currentItem);
      setTimeout(() => {
        this.addOne();
      }, 100);
    },
    commonAddOneForScanner() {
      if (this.isItBarcodeScanner) {
        setTimeout(() => {
          // Use addOneFromUser (not addOne) so the new row's Tax Yr field gets focused
          // the same way the '+' button does - needed when the 'Default cursor to
          // Parcel ID' setting is on, since that setting turns off the per-row
          // autofocus that would otherwise put the cursor there for us.
          this.addOneFromUser();
        }, 500);
      }
    },
    // Popup 1 ('Pending Payments Found'). Continue just dismisses it and lets popup 2 (if it
    // has content) follow; Cancel drops the whole batch, same as popup 2's CancelAll.
    closePendingPaymentPopup(fromWhere) {
      this.pendingPaymentList = [];
      this.showPendingPaymentPopup = false;
      if (fromWhere === 'cancel') {
        this.openConfirmPopUpForAllMsg('CancelAll');
      }
      this.maybeEmitUnpaidTaxesAdded();
    },
    openConfirmPopUpForAllMsg(fromWhere) {
      if (fromWhere === 'continue') {
        this.commonAddOneForScanner();
        this.showOrHidePopUpForAllMsg = false;
        this.allMessageText = [];
        this.errorMsgTaxYearTaxId = '';
        this.maybeEmitUnpaidTaxesAdded();
      } else if (fromWhere === 'continueAll') {
        this.showOrHidePopUpForAllMsg = false;
        this.statusCodeErrorList = [];
        this.mtgCodeErrorList = [];
        this.totalDueZeroErrorList = [];
        this.paymentExitsErrorList = [];
        this.errorMsgTaxYearTaxIdList = [];
        this.maybeEmitUnpaidTaxesAdded();
      } else if (fromWhere === 'CancelAll') {
        this.statusCodeErrorList = [];
        this.mtgCodeErrorList = [];
        this.totalDueZeroErrorList = [];
        this.paymentExitsErrorList = [];
        this.errorMsgTaxYearTaxIdList = [];
        this.showOrHidePopUpForAllMsg = false;
        this.setIsVisible(['pickListMakePaymentDialog', false]);
        this.$emit('input', []);
        setTimeout(() => {
          this.resetOnCancel();
        }, 100);
        // The clerk backed out of the whole batch - nothing left to commit, so drop the
        // pending emit instead of routing it through maybeEmitUnpaidTaxesAdded.
        this.awaitingUnpaidTaxesPopupClose = false;
      } else if (fromWhere === 'Cancel') {
        this.showOrHidePopUpForAllMsg = false;
        this.errorMsgTaxYearTaxId = '';
        this.allMessageText = [];
        const currentItem = this.editedItem[this.currentIndex];
        currentItem.taxId = null;
        this.resetOnCancel();
        this.awaitingUnpaidTaxesPopupClose = false;
      }
    },
    // Fires 'unpaidTaxesAdded' once "Add All Unpaids" is truly done - immediately when no
    // warning modal was raised, or once the clerk continues past whichever ones were (both
    // the pending-payment popup and the general status/mtg/due/pending popup can appear
    // in sequence, so this only emits once neither is still open).
    maybeEmitUnpaidTaxesAdded() {
      if (!this.awaitingUnpaidTaxesPopupClose) return;
      if (this.showPendingPaymentPopup || this.showOrHidePopUpForAllMsg) return;
      this.awaitingUnpaidTaxesPopupClose = false;
      this.$emit('unpaidTaxesAdded');
    },
    allMsgClass(textName) {
      if (textName === 'extraPayment') return 'ChangeColor';
      return '';
    },
    penaltyChangeManually(index) {
      const changedValue = { ...this.editedItem[index] };
      changedValue.penaltyChangedManually = true;
      this.$set(this.editedItem, index, changedValue);
    },

    handleManualChanges(index, item) {
      const {
        initialPenaltyAmt, initialTaxAmt, grossAssessed, taxAmt,
      } = this.editedItem[index];

      const taxPercentage = (taxAmt * 100) / initialTaxAmt;
      const changedValue = { ...this.editedItem[index] };
      changedValue.AIsVisible = false;
      const item1 = this.item(this.baseCrudKey);
      // eslint-disable-next-line max-len
      const taxAmountChangesCreateAudit = (this.paymentSettingItem || {}).taxAmountChangesCreateAudit || false;
      const { auditSummaryText, aIsVisible } = applyAuditForPayment({
        item,
        initialPenaltyAmt,
        initialTaxAmt,
        item1,
        taxAmountChangesCreateAudit,
      });

      // audit records are only needed tax-type is 'TAXPAYMENT'
      const isItTaxPayment = changedValue.taxType === 'TAXPAYMENT';
      changedValue.grossAssessed = (grossAssessed * taxPercentage) / 100;
      changedValue.auditSummary = isItTaxPayment ? auditSummaryText : '';
      changedValue.AIsVisible = isItTaxPayment ? aIsVisible : false;
      if (taxAmountChangesCreateAudit && aIsVisible && isItTaxPayment) {
        changedValue.previousTaxAmt = initialTaxAmt;
      }
      this.$set(this.editedItem, index, changedValue);
    },
    roundAmount(val, index) {
      const currentItem = this.editedItem[index];
      currentItem[val] = amountFormat(amountToNumber(currentItem[val]));
    },
    amountToNum(val, index) {
      const currentItem = this.editedItem[index];
      currentItem[val] = amountToNumber(currentItem[val]);
    },
    roundAmountForFee(val, index) {
      const curItem = this.feeseditDialog[index];
      curItem.feeAmount = amountFormat(amountToNumber(val));
    },
    amountToNumForFee(val, index) {
      const curItem = this.feeseditDialog[index];
      curItem.feeAmount = amountToNumber(val);
    },
    calculateTotalDue(index) {
      const currentItem = this.editedItem[index];
      const totalCaclAmt = amountToNumber(currentItem.penaltyAmt)
      + amountToNumber(currentItem.taxAmt) + amountToNumber(currentItem.totalFees);
      currentItem.total = amountFormat(amountToNumber(totalCaclAmt || 0));
    },
    handlePlusClass() {
      if (!this.paymentAddIconStatus) return 'addIconClass';
      return '';
    },
    handleCircleClass(textName) {
      if (textName === 'extraPayment' || textName === 'alreadyPayExits') return 'ChangeIconRedColor';
      if (textName === 'defaultText') return 'removeIcon';
      return 'ChangeIconYellowColor';
    },
    // async moreTaxFields() {
    //   const currentrec = this.item(this.baseCrudKey);
    //   const criteria = {
    //     limit: this.moreTaxLimit,
    //     skip: this.loadTaxIndex,
    //     fiscalYear: currentrec.fiscalYear,
    //     paymentNumber: currentrec.paymentNumber,
    //   };
    //   const res = await this.loadMoreTaxRecords({ criteria });
    //   const tempRec = [...this.editedItem];
    //   if (res.length > 0) {
    //     // eslint-disable-next-line array-callback-return
    //     res.map((values) => {
    //       tempRec.push(values);
    //     });

    //     this.editedItem = tempRec;
    //     this.loadTaxIndex += this.moreTaxLimit;
    //   }
    // },
    statusForHalf(taxAmt) {
      const amt = amountToNumber(taxAmt);
      return amt <= MIN_ALLOW_AMT_HALF;
    },
    // A barcode scanner is a keyboard wedge: it types the 11-digit barcode one character at a
    // time, so @input fires once per digit and only the last one carries the whole value. This
    // used to wait out a 300ms debounce to be sure the scan had finished. The length is a far
    // better "scan complete" signal than the clock - it costs nothing and, unlike a timer, it
    // does not depend on how fast a given scanner emits characters. That mattered: the counties
    // that complained about the pause run custom-configured scanners, and a timer short enough
    // to feel instant on one of them can fire mid-scan on another.
    handleBarCodeScan(barcodeNum, index) {
      // Anything short of a complete barcode is a partial scan or someone typing by hand; the
      // field's own blur/debounce path already covers manual entry. Deliberately >= and not
      // === : a scanner whose terminator comes through as a character would otherwise push the
      // field to 12 and the scan would be ignored outright.
      const raw = String(barcodeNum == null ? '' : barcodeNum).trim();
      if (!REGEX_VALIDATION.onlyNumerics.test(raw) || raw.length < 11) {
        this.isItBarcodeScanner = false;
        return;
      }
      // Trailing characters of a scan already being handled - the write below has not landed
      // yet, so the field still reads as a barcode.
      if (this.scanBeingHandled) return;

      const barcodeStr = raw.slice(0, 11);
      const scannedTaxYear = parseInt(barcodeStr.slice(0, 4), 10);
      const scannedTaxId = parseInt(barcodeStr.slice(4), 10);

      if (this.lastScannedBarcode === barcodeStr) {
        // Check if the barcode actually exists in the current tax details
        // (it may have been deleted, in which case re-scanning should be allowed)
        const existsInDetails = this.editedItem.some(
          (det, idx) => idx !== index
            && Number(det.taxYear) === scannedTaxYear
            && Number(det.taxId) === scannedTaxId,
        );
        if (existsInDetails) {
          console.warn('Duplicate barcode scan ignored: ', barcodeNum);
          this.flashWarn('Duplicate barcode scan ignored');
          return;
        }
      }
      this.lastScannedBarcode = barcodeStr;
      this.isItBarcodeScanner = true;
      this.scanBeingHandled = true;

      // Why this is not done inline. Writing taxYear mid-event left the Tax Yr box showing the
      // first few characters of the raw barcode ("20250" out of 20250022000): Vuetify does not
      // push a model value back into a field that still has focus, and nothing downstream
      // rewrites taxYear afterwards - commonLoadTaxInquiryFunc only reads it. The old 300ms
      // debounce hid this by writing long after the field had settled. A macrotask is enough to
      // get the same safety without the wait: the input event finishes, Vue flushes its render,
      // and any trailing character the scanner sends has arrived (and been swallowed by the
      // scanBeingHandled guard above) before the row is touched.
      setTimeout(() => {
        this.scanBeingHandled = false;
        const currentItem = this.editedItem[index];
        if (!currentItem) return;
        currentItem.taxYear = scannedTaxYear;
        currentItem.taxId = scannedTaxId;
        // Straight to the lookup rather than through postUpdateEditedItem's debounce: that
        // debounce exists to stop a query firing on every keystroke while a clerk types, and we
        // already know this value is complete. Going through it added a second 300ms on top of
        // the timer removed above, so a scan used to take ~600ms to produce a request.
        this.preUpdateEditedItem(currentItem, index, false, true);
      }, 0);
    },
    async handleSaveNewFee() {
      const newFeeItem = this.item('addFeeDialog');
      if (!newFeeItem.feeAmount || !newFeeItem.feeNumber) {
        return;
      }

      const currentItem = this.editedItem[this.feeDetailsIndex];

      try {
        // Get fee description from tax fee master data
        const filteredTaxMasterList = (this.taxFeeMasterData || [])
          .filter((ft) => ft.feeNumber === newFeeItem.feeNumber);
        const feeDescription = filteredTaxMasterList.length > 0 ? filteredTaxMasterList[0].feeDescription : '';

        // Create new fee object
        const newFee = {
          taxYear: newFeeItem.taxYear,
          taxId: newFeeItem.taxId,
          effectiveDate: newFeeItem.effectiveDate,
          feeNumber: newFeeItem.feeNumber,
          feeAmount: amountToNumber(newFeeItem.feeAmount),
          feeDescription,
          taxInquiryTransaction: currentItem.taxInquiryId,
        };

        // Update the current item's fees array
        const feeDetails = [...(currentItem.fees || [])];
        feeDetails.push(newFee);
        currentItem.fees = feeDetails;
        this.feeseditDialog = [...feeDetails];

        // Update total fees
        const totalFees = feeDetails.reduce((acc, fee) => acc + amountToNumber(fee.feeAmount), 0);
        currentItem.totalFees = amountFormat(totalFees);

        // Update total due
        this.calculateTotalDue(this.feeDetailsIndex);

        // Trigger UI updates
        this.$forceUpdate();
        this.somethingChanged();

        // Close dialog and reset form
        this.addFeeDialog = false;
        this.setItem(['addFeeDialog', {}]);
      } catch (error) {
        console.error('Error adding fee:', error);
        this.flashWarn('There was a problem adding the fee');

        // Revert local changes on error
        if (currentItem.fees && currentItem.fees.length) {
          currentItem.fees.pop();
          this.feeseditDialog = [...currentItem.fees];
          // eslint-disable-next-line max-len
          const totalFees = currentItem.fees.reduce((acc, fee) => acc + amountToNumber(fee.feeAmount), 0);
          currentItem.totalFees = amountFormat(totalFees);
          this.calculateTotalDue(this.feeDetailsIndex);
          this.somethingChanged();
        }
      }
    },

    taxFeesPostProcessTrans(items) {
      const updatedItems = [];
      for (let i = 0; i < items.length; i += 1) {
        const item = { ...items[i] };
        item.effectiveDate = item.effectiveDate ? toShortDate(item.effectiveDate)
          : item.effectiveDate;
        item.paymentDate = item.paymentDate ? toShortDate(item.paymentDate)
          : item.paymentDate;
        updatedItems.push(item);
      }
      return updatedItems;
    },
    addNewFeeRow() {
      const newFee = {
        feeNumber: null,
        feeDescription: '',
        feeAmount: 0,
        feeCreatedAtpayment: true,
      };
      this.feeseditDialog = [...this.feeseditDialog, newFee];
      this.updateTotalAfterFeeChange();
    },
    removeFeeRow(index) {
      const fees = [...this.feeseditDialog];
      fees.splice(index, 1);
      this.feeseditDialog = fees;
      this.updateTotalAfterFeeChange();
    },
    updateTotalAfterFeeChange() {
      // Don't update dialogTaxDetails totals during editing
      // This prevents the confusing UX where totals change before save
      // The totals will be updated when handleFeesItems is called on save

      // Only trigger UI updates for visual feedback in the dialog
      this.$forceUpdate();
    },
    handleFeeNumberChange(feeNumber, index) {
      const selectedFee = this.taxFeeMasterData.find((fee) => fee.feeNumber === feeNumber);
      if (selectedFee) {
        const fees = [...this.feeseditDialog];
        fees[index].feeDescription = selectedFee.feeDescription;
        this.feeseditDialog = fees;
      }
    },
    dataFromCommonDropDowns(val, whichField) {
      this.editedItem[whichField] = val;
    },
    handleSelectionChange() {
      // Handle individual checkbox selection
      this.$emit('selectionChanged', this.getSelectedItems());
    },
    getSelectedItems() {
      // Return array of selected items
      return this.editedItem.filter((item) => item.selected && !item.posted);
    },
    selectAll() {
      // Select all non-posted items
      this.editedItem.forEach((item) => {
        if (!item.posted) {
          // eslint-disable-next-line no-param-reassign
          item.selected = true;
        }
      });
      this.$emit('selectionChanged', this.getSelectedItems());
    },
    deselectAll() {
      // Deselect all items
      this.editedItem.forEach((item) => {
        // eslint-disable-next-line no-param-reassign
        item.selected = false;
      });
      this.$emit('selectionChanged', this.getSelectedItems());
    },
    toggleSelectAll() {
      if (this.selectAllChecked) {
        this.selectAll();
      } else {
        this.deselectAll();
      }
    },
    async handleDuplicateTaxDetailContinue() {
      this.duplicateTaxDetailDialog = false;
      const {
        firstData, paymentCriteria, commonLoadTaxInquiryFuncCriteria, item, isItLastIndex, isFromOnBlur,
      } = this.duplicateTaxDetailData;
      const index = this.duplicateTaxDetailIndex;
      try {
        const retPayments = await this.loadPayment({ criteria: paymentCriteria });
        await this.commonLoadTaxInquiryFunc(
          item, commonLoadTaxInquiryFuncCriteria, index, firstData, retPayments, false, isItLastIndex, isFromOnBlur,
        );
        this.addPaidByFunc(firstData);
      } catch (error) {
        console.error('Error loading tax data after duplicate continue:', error);
        this.flashWarn('There was a problem loading the tax information');
      } finally {
        // Deliberately does not touch isProcessingUpdate. This runs long after
        // commonUpdateEditedItem released the guard (it opened this dialog and returned), so by
        // now the flag may well belong to a queued lookup that started while the clerk was
        // reading the prompt - clearing it here would let two lookups overlap.
        this.somethingChanged();
        this.duplicateTaxDetailIndex = null;
        this.duplicateTaxDetailData = {};
      }
    },
    handleDuplicateTaxDetailCancel() {
      this.duplicateTaxDetailDialog = false;
      const index = this.duplicateTaxDetailIndex;
      if (index !== null && index >= 0) {
        const items = JSON.parse(JSON.stringify(this.value));
        items.splice(index, 1);
        this.$emit('input', items);
        this.somethingChanged();
      }
      this.duplicateTaxDetailIndex = null;
      this.duplicateTaxDetailData = {};
    },
  },
  watch: {
    selectedComponentCriteria() {
      this.resaleFeeApplied = false;
    },
    isItTaxRecordNCounter() {
      this.addOneFromUser();
    },
    isVisibleProp(preVal) {
      if (!preVal) {
        this.ownerInfo = [];
        this.setMinimizeTRToggleApiCalls(null);
        this.showOrHidePopUpForAllMsg = false;
        this.allMessageText = [];
      } else {
        this.fromOtherSourcesUpdateEditedItem();
        // re-opens reuse the mounted component, so mounted() cannot place the cursor again
        this.focusParcelLookup();
      }
    },
    value: {
      handler(newVal) {
        this.$store.commit('tax/taxPayment/setTaxDetails', newVal);
      },
      deep: true,
    },
    selectedItemsCount: {
      handler(newCount) {
        // Update select all checkbox state based on selection
        this.selectAllChecked = newCount > 0 && newCount === this.selectableItemsCount;
      },
      immediate: true,
    },
    showCertNumber: {
      handler(val) {
        this.headers = this.getHeaders(val);
      },
      immediate: true,
    },
  },
};
</script>
<style scoped>
.blue-text {
  text-align: end;
  color: #2196f3 !important;
  padding: 0.5rem;
  border-top: 1px solid rgb(217, 214, 214);
}
.blue-text-left {
  text-align: start;
  color: #2196f3 !important;
  padding: 0.5rem;
  border-top: 1px solid rgb(217, 214, 214);
}

::v-deep .v-data-table-header tr {
  white-space: nowrap;
}
::v-deep .v-list-item__title {
  font-size: 0.75rem;
}
::v-deep .text-center {
  padding: 1px !important;
}
.v-application p {
margin-bottom: 0 !important;
margin-left: 1rem;
}
.blue-font {
  color: #2196f3 !important;
}
::v-deep .v-text-field.v-text-field--solo.v-input--dense > .v-input__control {
    min-height: 32px;
}
::v-deep .v-text-field.v-text-field--solo .v-input__control input {
width: 34px;
}
.ChangeColor {
  color: red;
}
</style>
